<template>
  <div v-if="showNoDataImgForUser">
    <div class="progressImgDataContainer">
      <div class="progressDataText">
        <h4>Your data has been successfully added to Weavr!</h4>
        <p>Please check back in 24 hours.</p>
      </div>
      <div class="progressImgWrapper">
        <img
          src="Icons_SVG/progressDataImgUpdated.svg"
          alt="data in progress"
        />
      </div>
    </div>
  </div>
  <div v-else id="dashboard">
    <div
      data-html2canvas-ignore="true"
      v-show="
        loader0

      "
    >
      <Loader />
    </div>
    <!-- india map and trendline start  -->
    <div class="card revampCard">
      <!-- <div style="display: flex; width: 100%;" class="flex-wrap"> -->
      <!-- <div class="mr-2">
                    <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">{{
                        translatedLang["Date Range"][selectedLanguage.key] }}</div>
                    <date-range-picker v-model="dateRange" opens='right' :autoApply="true"
                        :locale-data="{ format: 'dd mmm yyyy' }" :show-dropdowns="true" :min-date="minDate"
                        :max-date="maxDate">
                    </date-range-picker>
                </div> -->
      <!-- <div class="customMultiselectCommon mr-2" v-if="viewPlatformList.length"
                    style="min-width: 170px; max-width:200px">
                    <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">{{
                        translatedLang["Platform"][selectedLanguage.key] }}</div>
                    <multiselect :custom-label="updateSelectedLabels" track-by="key" label="value"
                        @input="changePlatform" v-model="selectedTrendLinePlatform" :options="viewPlatformList"
                        :multiple="false" :searchable="false" placeholder="Select Platform" :showLabels="false"
                        :close-on-select="true" :allow-empty="false" class="text-capitalize">
                        <template #option="{ option }">
                            <div class="custom-option text-capitalize">
                                <span>{{ option.value.replaceAll('_', ' ') }}</span>
                            </div>
                        </template>
                    </multiselect>
                </div>
                <div class="customMultiselectCommon" v-if="viewSegmentData.length" style="width:190px">
                    <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">{{
                        translatedLang["Category"][selectedLanguage.key] }}</div>
                    <multiselect v-model="selectedSegementForTrendline"
                        :options="[getAllCategoryforAllKeyOption(), ...viewSegmentData]" :multiple="false"
                        :searchable="false" label="value" track-by="key" placeholder="Select Category"
                        :showLabels="false" :close-on-select="true" :allow-empty="false" class="text-capitalize">
                        <template #option="{ option }">
                            <div class="custom-option text-capitalize">
                                <span>{{ option.value }}</span>
                            </div>
                        </template>
                    </multiselect>

                </div> -->
      <!-- <div>
                    <button @click="filterApply" class="btn primarycolor ml-3" style="margin-top:1.4rem">
                        {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
                    </button>
                </div> -->

      <!-- <div class="custom_dropdown customMultiselect" style="max-width:40%">
            <multiselect
              v-model="selectedProductListForTrendline"
              :options="viewProductList"
              :multiple="true"
              placeholder="Search Product"
              select-label=""
              deselect-label=""
              selectedLabel=""
              :closeOnSelect="false"
              @select="changeProductName($event)"
              @remove="changeProductName($event)"
            >
              <template slot="option" slot-scope="{ option }">
                <div v-if="option.$isLabel">
                  <strong>{{ option.$groupLabel }}</strong>
                </div>
                <div v-else>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedProductListForTrendline"
                  />
                  <span class="option__title ml-3">{{ option }}</span>
                </div>
              </template>
</multiselect>
</div> -->

      <!-- <div class="lastUpdated">
          Last Updated: {{ lastUpdated }}
        </div> -->
      <!-- </div> -->
      <div
        class="d-flex gap-3 flex-wrap tw-items-center"
        id="avaibility-filters"
      >
        <div class="mr-2">
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Date"][selectedLanguage.key] }}
          </div>
          <date-range-picker
            style="width: 150px"
            v-model="lossBuyboxTableDateRange"
            :show-dropdowns="true"
            opens="right"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="minDateTableDateRange"
            :max-date="maxDateTableDateRange"
            :single-date-picker="true"
            :ranges="false"
          >
            <!-- @update="getBuyBoxTable" -->
          </date-range-picker>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1 ml-0"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Platform"][selectedLanguage.key] }}
          </div>

          <multiselect
            @input="changeTableCategory"
            v-model="selectedPlatform"
            class="text-capitalize"
            :options="platformList"
            track-by="key"
            label="value"
            :custom-label="updateSelectedLabels"
            :multiple="false"
            :searchable="false"
            placeholder="Select Platform"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="true"
          >
            <template #option="{ option }">
              <div class="tw-flex tw-gap-2">
                <div class="custom-option text-capitalize">
                  {{ option.value?.replaceAll("_", " ") }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Category"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="selectedTableCategory"
            class="text-capitalize"
            :options="categoryList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Category"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            :limit="
              selectedTableCategory?.length == categoryList?.length ? 1 : 100
            "
            @input="handleChangeCategory"
          >
            <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="selectedTableCategory"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value?.replaceAll("_", " ")
              }}</span>
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Sub Category"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="selectedTableSubCategory"
            class="text-capitalize"
            :options="subCategoryList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Sub Category"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            :limit="
              selectedTableSubCategory?.length == subCategoryList?.length
                ? 1
                : 100
            "
            @input="handleChangeSubCategory"
          >
            <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="selectedTableSubCategory"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value?.replaceAll("_", " ")
              }}</span>
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Brand"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="lossSelectedBrand"
            class="text-capitalize"
            :options="lossBrandList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Brand"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            :limit="
              lossSelectedBrand?.length == lossBrandList?.length ? 1 : 100
            "
            @input="handleBrand"
          >
            <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="lossSelectedBrand"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value.replaceAll("_", " ")
              }}</span>
            </template>
            <!-- <template #singleLabel="{ option }">
              {{ option.displayname.replaceAll("_", " ") }}
            </template> -->
          </multiselect>
        </div>
        <div
          class="custom_pincode_dropdown customMultiselect mr-3"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Pincode"][selectedLanguage.key] }}
          </div>
          <treeselect
            v-model="lossSelectedPIN"
            :options="lossPINList"
            track-by="id"
            label="label"
            value-consists-of="LEAF_PRIORITY"
            :limit="1"
            :disable-branch-nodes="false"
            placeholder="Select PIN(s)"
            :multiple="true"
            :searchable="true"
            @select="handleSelectTopFilterPinChange"
          >
            <span slot="noResult">{{
              translatedLang["No elements found"][selectedLanguage.key]
            }}</span>
          </treeselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Batch - Time"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="lossSelectedBatch"
            class="text-capitalize"
            :options="lossBatchList"
            track-by="batch"
            label="displayname"
            :multiple="false"
            :searchable="false"
            placeholder="Select Batch"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="true"
          >
            <template #option="{ option }">
              <span class="option__title ml-3 text-capitalize">{{
                option.displayname?.replaceAll("_", " ")
              }}</span>
            </template>
            <template #singleLabel="{ option }">
              {{ option.displayname?.replaceAll("_", " ") }}
            </template>
          </multiselect>
        </div>
        <button class="btn primarycolor py-2 tw-mt-4" @click="filterApply">
          {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
        </button>
      </div>
    </div>
    <div class="row revampCard pb-0 card-deck">
      <div
        class="col-12 mb-3 mb-lg-0 card mr-0 mr-lg-2 ml-0 ml-lg-1"
        :class="[getKeyForAvailabilityPincode && 'col-lg-6']"
        style="border: none"
      >
        <div
          class="mb-0"
          v-if="procesedPieChartData.length && pieChartAvailabilityDataShow"
        >
          <h5
            class="borderBottom graphHeading pb-3"
            style="margin-bottom: 5px !important"
          >
            {{ tempSelectedTrendLinePlatform?.value?.replaceAll("_", " ") }}
          </h5>
          <pieChart :data="procesedPieChartData" />
        </div>
        <div
          v-else-if="!pieChartAvailabilityDataShow && loader"
          class="onLoadingData mt-0"
        >
          {{ translatedLang["Loading"][selectedLanguage.key] }}...
        </div>
        <div
          v-else
          class="text-danger d-flex justify-content-center border border-danger rounded mt-1 noData"
        >
          {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
        </div>
      </div>

      <div
        class="col-12 col-lg-6 card mr-0 ml-0"
        style="border: none"
        v-if="getKeyForAvailabilityPincode"
      >
        <div
          class="mb-0"
          v-if="procedIndiaMapData.length && indiaMapAvailabilityDataShow"
        >
          <div>
            <h5
              class="borderBottom pb-3 graphHeading"
              style="margin-bottom: 5px !important"
            >
              {{ tempSelectedTrendLinePlatform?.value?.replaceAll("_", " ") }}
            </h5>
            <div class="d-flex justify-content-end">
              <!-- <div class="mr-3">Availability % :</div> -->
              <span class="mr-3">
                <i
                  class="fa fa-circle"
                  style="color: rgba(173, 247, 182, 1)"
                ></i>
                >= 90%
              </span>
              <span class="mr-3">
                <i
                  class="fa fa-circle"
                  style="color: rgba(194, 195, 255, 1)"
                ></i>
                < 90%
              </span>
              <span class="mr-3">
                <i
                  class="fa fa-circle"
                  style="color: rgba(255, 242, 194, 1)"
                ></i>
                <= 70%
              </span>
              <span class="mr-3">
                <i
                  class="fa fa-circle"
                  style="color: rgba(255, 211, 211, 1)"
                ></i>
                <= 20%
              </span>
            </div>
          </div>
          <indiaMap :data="procedIndiaMapData" suffix="%" />
        </div>
        <div
          v-else-if="!indiaMapAvailabilityDataShow && loader2"
          class="onLoadingData mt-0"
        >
          {{ translatedLang["Loading"][selectedLanguage.key] }}...
        </div>
        <div
          v-else
          class="text-danger d-flex justify-content-center border border-danger rounded mt-1 noData"
        >
          {{ translatedLang["No Data Available"][selectedLanguage.key] }}
        </div>
      </div>
    </div>
    <div class="row revampCard pb-0">
      <div class="col-12 card mr-0 ml-0 mb-0" style="border: none">
        <div class="mb-0">
          <div
            class="d-flex justify-content-between tw-items-center tw-pb-2 borderBottom"
          >
            <h4 class="graphHeading pb-2" style="margin-bottom: 0px !important">
              {{ translatedLang["Availability Trend"][selectedLanguage.key] }}
            </h4>
            <div style="margin-top: 0">
              <b-button-toolbar
                class="float-right"
                aria-label="Toolbar with buttons group"
              >
                <b-form-radio-group
                  class="radiohide"
                  id="radiosBtn"
                  buttons
                  button-variant="outline-secondary"
                  v-model="sovInterval"
                  name="radiosBtn"
                >
                  <b-form-radio
                    class="mx-0"
                    style="padding: 0 8px !important"
                    value="day"
                    >{{
                      translatedLang["Day"][selectedLanguage.key]
                    }}</b-form-radio
                  >
                  <b-form-radio
                    class="mx-0"
                    style="padding: 0 8px !important"
                    value="week"
                    >{{
                      translatedLang["Week"][selectedLanguage.key]
                    }}</b-form-radio
                  >
                  <b-form-radio
                    class="mx-0"
                    style="padding: 0 8px !important"
                    value="month"
                    >{{
                      translatedLang["Month"][selectedLanguage.key]
                    }}</b-form-radio
                  >
                </b-form-radio-group>
              </b-button-toolbar>
            </div>
            <!-- <div
              class="col-md-2 px-0 customMultiselect mb-2"
              v-if="Object.keys(viewPinListTrendLine)?.length"
            >
              <treeselect
                v-model="selectedPinForTrendLine"
                limit="1"
                :options="viewPinListTrendLine"
                value-consists-of="LEAF_PRIORITY"
                :disable-branch-nodes="false"
                :placeholder="
                  translatedLang['Select PIN'][selectedLanguage.key]
                "
                :multiple="true"
                @input="getTrendlineGraphData()"
                :searchable="true"
              >
                <span slot="noResult">{{
                  translatedLang["No elements found"][selectedLanguage.key]
                }}</span>
              </treeselect>
            </div> -->
          </div>
        </div>
        <div
          v-if="procedTrandLineData?.xAxis?.length && availabilityTrendDataShow"
        >
          <lineChart :data="procedTrandLineData" />
        </div>
        <div
          v-else-if="!availabilityTrendDataShow && loader1"
          class="onLoadingData mt-1"
        >
          {{ translatedLang["Loading"][selectedLanguage.key] }}...
        </div>
        <div
          v-else
          class="text-danger d-flex justify-content-center border border-danger rounded mt-1 noData"
        >
          {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
        </div>
      </div>
    </div>
    <!-- india map and trendlind end -->
    <div
      class="card revampCard d-flex flex-col flex-lg-row justify-content-between"
    >
      <div class="d-flex flex-wrap" id="avaibility-filters">
        <!-- <div class="mr-2">
          <datepicker placeholder="Select Date" @input="dateChange" v-model="date" />
        </div> -->
        <div class="mr-2">
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 400; color: #1e1e1e"
          >
            {{ translatedLang["Date"][selectedLanguage.key] }}
          </div>
          <date-range-picker
            style="width: 150px"
            v-model="date"
            :show-dropdowns="true"
            opens="right"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="tableDateRangeMin"
            :max-date="tableDateRangeMax"
            :single-date-picker="true"
            :ranges="false"
            @update="handleDateChange"
          >
          </date-range-picker>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1 ml-0"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Platform"][selectedLanguage.key] }}
          </div>

          <multiselect
            @input="handlePlatformSelection"
            v-model="selectedPincodeProductPlatform"
            class="text-capitalize"
            :options="pincodeProductPlatformList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Platform"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            :limit="
              selectedPincodeProductPlatform?.length ==
              pincodeProductPlatformList?.length
                ? 1
                : 100
            "
          >
            <template #option="{ option }">
              <div class="tw-flex tw-gap-2">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedPincodeProductPlatform"
                />
                <div class="custom-option text-capitalize">
                  {{ option.value?.replaceAll("_", " ") }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Category"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="selectedPincodeProductTableCategory"
            class="text-capitalize"
            :options="pincodeProductCategoryList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Category"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            :limit="
              selectedPincodeProductTableCategory?.length ==
              pincodeProductCategoryList?.length
                ? 1
                : 100
            "
            @input="handleChangePincodeProductCategory"
          >
            <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="selectedPincodeProductTableCategory"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value?.replaceAll("_", " ")
              }}</span>
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Sub Category"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="selectedPincodeProductTableSubCategory"
            class="text-capitalize"
            :options="pincodeProductSubCategoryList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Sub Category"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            :limit="
              selectedPincodeProductTableSubCategory?.length ==
              pincodeProductSubCategoryList?.length
                ? 1
                : 100
            "
            @input="handleChangePincodeProductSubCategory"
          >
            <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="selectedPincodeProductTableSubCategory"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value?.replaceAll("_", " ")
              }}</span>
            </template>
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Brand"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="lossSelectedPincodeProductBrand"
            class="text-capitalize"
            :options="pincodeProductBrandList"
            track-by="key"
            label="value"
            :multiple="true"
            :searchable="false"
            placeholder="Select Brand"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            :limit="
              lossSelectedPincodeProductBrand?.length ==
              pincodeProductBrandList?.length
                ? 1
                : 100
            "
            @input="handlePincodeProductBrand"
          >
            <template #option="{ option }">
              <input
                type="checkbox"
                :value="option"
                v-model="lossSelectedPincodeProductBrand"
              />
              <span class="option__title ml-3 text-capitalize">{{
                option.value.replaceAll("_", " ")
              }}</span>
            </template>
            <!-- <template #singleLabel="{ option }">
              {{ option.displayname.replaceAll("_", " ") }}
            </template> -->
          </multiselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 180px; max-width: 180px"
        >
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Product"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="lossSelectedPincodeProductId"
            limit="1"
            :options="lossProductList"
            :multiple="true"
            :searchable="true"
            placeholder="Select Product"
            :close-on-select="false"
            :allow-empty="true"
            :showLabels="false"
            track-by="key"
            label="value"
            :limit="
              lossSelectedPincodeProductId?.length == lossProductList?.length
                ? 1
                : 1000
            "
            @input="handleProductIdSelection"
          >
            <template #option="{ option }">
              <div>
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedPincodeProductId"
                />
                <span class="option__title ml-3">{{ option.value }}</span>
              </div>
            </template>
          </multiselect>
        </div>
        <div
          class="custom_pincode_dropdown customMultiselect mr-3"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Pincode"][selectedLanguage.key] }}
          </div>
          <treeselect
            v-model="lossSelectedPincodeProductPIN"
            :options="lossPincodeProductPINList"
            track-by="id"
            label="label"
            value-consists-of="LEAF_PRIORITY"
            :limit="1"
            :disable-branch-nodes="false"
            placeholder="Select PIN(s)"
            :multiple="true"
            :searchable="true"
            @select="handleSelectProductPinChange"
          >
            <span slot="noResult">{{
              translatedLang["No elements found"][selectedLanguage.key]
            }}</span>
          </treeselect>
        </div>
        <div
          class="customMultiselectCommon mr-2"
          style="min-width: 200px; max-width: 200px"
        >
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Batch - Time"][selectedLanguage.key] }}
          </div>
          <multiselect
            v-model="lossSelectedPincodeProductBatch"
            class="text-capitalize"
            :options="lossBatchList"
            track-by="batch"
            label="displayname"
            :multiple="false"
            :searchable="false"
            placeholder="Select Batch"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="true"
          >
            <template #option="{ option }">
              <span class="option__title ml-3 text-capitalize">{{
                option.displayname?.replaceAll("_", " ")
              }}</span>
            </template>
            <template #singleLabel="{ option }">
              {{ option.displayname?.replaceAll("_", " ") }}
            </template>
          </multiselect>
        </div>
        <!-- <div
          class="customMultiselectCommon mr-2"
          style="width: 170px"
          v-if="segmentDropdown.isSegment"
        >
          <div
            class="mb-1 ml-1"
            style="font-size: 14px; font-weight: 400; color: #1e1e1e"
          >
            {{ translatedLang["Category"][selectedLanguage.key] }}
          </div>
          <multiselect
            @input="filterProcutListForAvailMetricTable(true)"
            v-model="segmentDropdown.selectedSegment"
            :options="[
              getAllCategoryforEmptyKeyOption(),
              ...segmentDropdown.options,
            ]"
            :multiple="false"
            :searchable="false"
            label="value"
            track-by="key"
            placeholder="Select Category"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="false"
            class="text-capitalize"
          >
            <template #option="{ option }">
              <div class="custom-option text-capitalize">
                <span>{{ option.value }}</span>
              </div>
            </template>
          </multiselect>
        </div> -->
        <!-- <div
          class="mr-2 customMultiselect"
          style="width: 400px"
          v-if="segmentDropdown.isSegment"
        >
          <div class="custom_dropdown customMultiselectCommon">
            <div
              class="mb-1 ml-1"
              style="font-size: 14px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Product"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="segmentDropdown.selectedProduct"
              :options="segmentDropdown.productFilterList"
              track-by="key"
              label="value"
              :multiple="false"
              :placeholder="
                translatedLang['Search Product'][selectedLanguage.key]
              "
              select-label=""
              deselect-label=""
              selectedLabel=""
              :closeOnSelect="true"
            >
              <template #option="{ option }">
                <div class="custom-option text-capitalize" :title="option">
                  <span>{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div> -->
        <!-- <multiselect v-model="locationDropdown.checkSelectedPins" :options="locationDropdown.options" :multiple="true"
            group-values="pins" group-label="City" :group-select="true" placeholder="Select PIN(s)" track-by="pin"
            label="pin" selectGroupLabel="Select group" deselectGroupLabel="Deselect group" selectLabel="Select"
            deselectLabel="Remove" @input="processSelectedPin()">
            <span slot="noResult">Oops! No
              elements found. Consider changing the search query.</span>
            </multiselect> -->
        <!-- </div> -->
        <!-- <div
          class="customMultiselect"
          style="width: 13.5rem"
          v-if="locationDropdown.options.length"
        >
          <div
            class="mb-1 ml-1"
            style="font-size: 14px; font-weight: 400; color: #1e1e1e"
          >
            {{ translatedLang["Pincode"][selectedLanguage.key] }}
          </div>
          <treeselect
            v-model="locationDropdown.checkSelectedPins"
            :options="locationDropdown.options"
            limit="1"
            value-consists-of="LEAF_PRIORITY"
            :disable-branch-nodes="false"
            :placeholder="translatedLang['Select PIN'][selectedLanguage.key]"
            :multiple="true"
            :searchable="true"
          >
            <span slot="noResult">{{
              translatedLang["No elements found"][selectedLanguage.key]
            }}</span>
          </treeselect> -->
        <!-- <multiselect v-model="locationDropdown.checkSelectedPins" :options="locationDropdown.options" :multiple="true"
            group-values="pins" group-label="City" :group-select="true" placeholder="Select PIN(s)" track-by="pin"
            label="pin" selectGroupLabel="Select group" deselectGroupLabel="Deselect group" selectLabel="Select"
            deselectLabel="Remove" @input="processSelectedPin()">
            <span slot="noResult">Oops! No
              elements found. Consider changing the search query.</span>
            </multiselect> -->
        <!-- </div> -->
        <button
          @click="handleExportFilter"
          class="btn exportButton mt-4 mr-2 px-3"
        >
          {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
        </button>
        <div class="d-lg-none" v-if="client === 'india_gate'">
          <button
            class="exportButton dropdown-toggle"
            type="button"
            ref="clrBtn"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            @click="toggleDropdown"
          >
            {{ translatedLang["Export"][selectedLanguage.key] }}
          </button>
          <div class="CustomDropdown" v-if="isDropdown">
            <div class="customItem" @click="downloadExel">
              {{
                translatedLang["Export top 20 products"][selectedLanguage.key]
              }}
            </div>
            <div class="customItem" @click="downloadLastExel">
              {{ translatedLang["Export last 2 months"][selectedLanguage.key] }}
            </div>
          </div>
        </div>
        <div
          class="d-lg-none"
          v-else
          style="display: flex; justify-content: end"
        >
          <button
            @click="downloadStandardExel"
            class="ui button exportButton ml-1 mt-4"
          >
            {{ translatedLang["Export"][selectedLanguage.key] }}
          </button>

          <!-- <button @click="downloadLastExel" class="ui button exportButton ml-1">Export last 2 months</button> -->
        </div>
      </div>

      <div class="d-none d-lg-block" v-if="client === 'india_gate'">
        <button
          class="exportButton dropdown-toggle"
          type="button"
          ref="clrBtn"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          @click="toggleDropdown"
        >
          Export
        </button>
        <div class="CustomDropdown" v-if="isDropdown">
          <div class="customItem" @click="downloadExel">
            {{ translatedLang["Export top 20 products"][selectedLanguage.key] }}
          </div>
          <div class="customItem" @click="downloadLastExel">
            {{ translatedLang["Export last 2 months"][selectedLanguage.key] }}
          </div>
        </div>
      </div>
      <div
        class="d-none d-lg-block"
        v-else
        style="display: flex; justify-content: end"
      >
        <button
          @click="downloadStandardExel"
          class="ui button exportButton ml-1 mt-4"
        >
          {{ translatedLang["Export"][selectedLanguage.key] }}
        </button>

        <!-- <button @click="downloadLastExel" class="ui button exportButton ml-1">Export last 2 months</button> -->
      </div>
    </div>
    <div class="card p-2 revampCard">
      <div>
        <!-- <div class="d-flex justify-content-end mb-2"> -->
        <!-- <div class="mr-3">Availability % :</div> -->

        <!-- <span class="mr-3">
            <i class="fa fa-circle" style="color: #c8d6cd"></i> > 90%
          </span>
          <span class="mr-3">
            <i class="fa fa-circle" style="color: yellow"></i>
            < 90% </span>
              <span class="mr-3">
                <i class="fa fa-circle" style="color: #b2bdff"></i>
                < 70% </span>
                  <span class="mr-3">
                    <i class="fa fa-circle" style="color: #ffbeb5"></i>
                    < 20% </span> -->
        <!-- </div> -->
        <div
          v-if="mainTableData?.data?.length && availabilityTableDataShow"
          class="summaryContainer"
        >
          <table
            id="indiagate-dashboard-table"
            v-if="mainTableData?.data?.length"
            class="tw-w-full"
          >
            <thead class="thead-normal">
              <tr>
                <th
                  v-for="(head, idx) in mainTableData?.header"
                  :key="head.key"
                >
                  <div
                    class="tw-flex tw-items-center tw-justify-center tw-gap-2"
                  >
                    <img v-if="head.img" style="width: 19px" :src="head.img" />
                    <div>
                      {{ head.value }}
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in mainTableData?.data" :key="row.link">
                <td
                  v-for="(col, idx) in mainTableData?.header"
                  :key="col.key"
                  :style="[
                    row.platform[col.key] && {
                      background: colorMapping[row.platform[col.key].color],
                    },
                  ]"
                  class="tw-max-w-[250px]"
                >
                  <div
                    v-if="col.key == 'product_name'"
                    class="text-center pr-2 pl-1 py-1 tw-max-w-[550px]"
                  >
                    <span class="text-capitalize tw-max-w-[550px] tw-whitespace-normal tw-break-words">{{ row.name.value }}</span>
                  </div>
                    <div
                    v-if="col.key == 'sku'"
                    class="text-center pr-2 pl-1 py-1 tw-max-w-[550px]"
                  >
                    <span class="text-capitalize tw-max-w-[550px] tw-whitespace-normal tw-break-words">{{ row.sku.value }}</span>
                  </div>
                  <div v-if="col.key == 'segment'" style="padding: 4px">
                    <span class="text-capitalize" code>{{
                      row.segment.value.replaceAll("_", " ")
                    }}</span>
                  </div>
                  <div
                    class="d-flex justify-content-between"
                    style="padding: 4px"
                    v-if="row.platform[col.key]"
                  >
                    <!-- <div>
                    <div class="info_mrp">MRP: {{ row.platform[col.key].mrp }}</div>
                    <div class="info_price">Price: {{ row.platform[col.key].offer }}</div>
                  </div> -->
                    <div class="align-items-start" style="z-index: 10">
                      <div
                        @click="
                          getKeyForAvailabilityPincode &&
                            processModal(
                              row.platform[col.key].location,
                              row.name,
                              1
                            )
                        "
                        :class="[
                          getKeyForAvailabilityPincode && 'avail_modal_cta',
                        ]"
                      >
                        {{
                          translatedLang["Available on"][selectedLanguage.key]
                        }}
                        : {{ row.platform[col.key].total_available
                        }}{{
                          getKeyForAvailabilityPincode
                            ? `
                                                ${
                                                  translatedLang["pincodes"][
                                                    selectedLanguage.key
                                                  ]
                                                }`
                            : ""
                        }}
                      </div>
                      <div
                        @click="
                          getKeyForAvailabilityPincode &&
                            processModal(
                              row.platform[col.key].location,
                              row.name,
                              0
                            )
                        "
                        :class="[
                          getKeyForAvailabilityPincode && 'unavail_modal_cta',
                        ]"
                      >
                        {{
                          translatedLang["Unavailable on"][selectedLanguage.key]
                        }}
                        : {{ row.platform[col.key].total_unavailable
                        }}{{
                          getKeyForAvailabilityPincode
                            ? `
                                                ${
                                                  translatedLang["pincodes"][
                                                    selectedLanguage.key
                                                  ]
                                                }`
                            : ""
                        }}
                      </div>
                    </div>

                    <div class="d-flex">
                      <div
                        @click="
                          processTrendLineModal(col.key, row.segment, row.name)
                        "
                        class="icon mr-2"
                      >
                        <i class="fa fa-line-chart"></i>
                      </div>
                      <a
                        :href="row.platform[col.key].link"
                        v-if="row.platform[col.key].link"
                        class="icon"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><i class="fa fa-external-link"></i
                      ></a>
                    </div>
                  </div>
                  <div
                    v-else
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <div
                      v-show="
                        !(col.key == 'product_name' || col.key == 'segment' || col.key == 'sku')
                      "
                    >
                      {{ translatedLang["NL"][selectedLanguage.key] }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-else-if="!availabilityTableDataShow && loader8"
          class="onLoadingData mt-0"
        >
          {{ translatedLang["Loading"][selectedLanguage.key] }}...
        </div>
        <div
          v-else
          class="text-danger d-flex justify-content-center border border-danger rounded mt-1 noData"
        >
          {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
        </div>
      </div>
    </div>
    <b-modal
      size="lg"
      class="customModal"
      id="trendLineModal"
      hide-footer
      :title="modalData.heading.key"
      v-model="showModal"
    >
      <div
        class="alert alert-danger p-3"
        v-if="!modalData.tableData.length"
        role="alert"
      >
        {{ translatedLang["No Data"][selectedLanguage.key] }}!!
      </div>
      <div v-else class="p-2" id="#modalContainer">
        <div class="tw-text-sm tw-w-[50%] tw-flex mb-2" style=" float:right; gap: 2px;" v-if="modalData.tableHeader.length==3">
            <div class="legend-item tw-w-full tw-text-[12px]" >
              <span class="tw-font-bold">NL :</span>
              <span class="tw-ml-1"> Not Listed</span>
            </div>
            <div class="legend-item tw-w-full tw-text-[12px]" >
              <span class="tw-font-bold">NF :</span>
              <span class="tw-ml-1"> Not Found</span>
            </div>
            <div class="legend-item tw-w-full tw-text-[12px]" >
              <span class="tw-font-bold tw-text-[#DB1010] tw-w-[35px]">OOS : </span>
              <span class="tw-ml-1 "> Out of Stock</span>
            </div>
        </div>
        <table id="modalTable" class="table">
          <thead>
            <tr  style="font-family:poppins">
              <th
                v-for="(head, idx) in modalData.tableHeader"
                :key="head + idx"
              >
                {{ head.value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, i) in modalData.tableData"
              :key="row.location_name + i"
               style="font-family:poppins"
            >
              <td v-for="head of modalData.tableHeader" :key="head.key">
                <div v-if="head.key=='pincode'">
                   <b-badge
                    class="mr-2 p-1"
                    style="font-size: 12px; cursor: copy"
                    v-for="code in row.data"
                    :key="code.pincode"
                    variant="light"
                    @click="copyToClipboard(code.pincode)"
                    ><i
                      class="fa fa-circle mr-1 mt-1"
                      :style="[
                        code.available == 1
                          ? { color: 'var(--green)' }
                          : { color: 'var(--red)' },
                      ]"
                    ></i
                    >{{ code.pincode }}</b-badge
                  >
                </div>
                <div v-if="head.key=='status'">
                    <div  v-for="status in row.data" :key="status.pincode">{{ status.status }}</div>
                </div>
               <div v-else>{{ row[head.key] }}</div>
              </td>
              <!-- <td>{{ row.location_name }}</td> -->
              <!-- <td>
                <div>
                  <b-badge
                    class="mr-2 p-1"
                    style="font-size: 12px; cursor: copy"
                    v-for="code in row.data"
                    :key="code.pincode"
                    variant="light"
                    @click="copyToClipboard(code.pincode)"
                    ><i
                      class="fa fa-circle mr-1 mt-1"
                      :style="[
                        code.available == 1
                          ? { color: 'var(--green)' }
                          : { color: 'var(--red)' },
                      ]"
                    ></i
                    >{{ code.pincode }}</b-badge
                  >
                </div>
              </td>
              <td  v-for="status in row.data" :key="status.pincode">{{ status.status }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal
      size="xl"
      class="customModal"
      id="trendLineModal"
      hide-footer
      style="z-index: 3000 !important; text-transform: capitalize"
      :title="selectedProductTrendlineModal.value"
      v-model="showTrendLineModal"
    >
      <!-- <div class="alert alert-danger p-3"  role="alert">
        No Data!!
      </div> -->
      <div
        class="p-2 w-100"
        id="#modalContainer"
        v-if="procedModalTrandLineData.xAxis"
      >
        <div style="display: flex; width: 100%" class="flex-wrap">
          <div class="mr-2 ml-lg-2">
            <div
              class="mb-1 ml-1"
              style="font-size: 14px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Date Range"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              v-model="trendlineModalDateRange"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="tableModalDateRangeMin"
              :max-date="tableModalDataRangeMax"
              @update="dateChangeModalTrendLine"
            >
            </date-range-picker>
          </div>
          <div
            style="width: 12rem"
            class="customMultiselectCommon mr-2"
            v-if="platformList"
          >
            <div
              class="ml-1 mb-1"
              style="font-size: 14px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Platform"][selectedLanguage.key] }}
            </div>
            <!-- <select class="form-control text-capitalize" v-model="selectedPlatformTrendlineModal"
              @change="changeModalPlatform(false)">
              <option v-for="(option, i) in viewPlatformList" :key="option + i + 'p2'" :value="option"
                class="text-capitalize">
                {{ option.replaceAll("_", " ") }}
              </option>
            </select> -->
            <multiselect
              :custom-label="updateSelectedLabels"
              @input="changeModalPlatform(false)"
              v-model="selectedPlatformTrendlineModal"
              track-by="key"
              label="value"
              :options="viewPlatformList"
              :multiple="false"
              :searchable="false"
              placeholder="Select Platform"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="text-capitalize"
            >
              <template #option="{ option }">
                <div class="custom-option text-capitalize">
                  <span>{{ option.value.replaceAll("_", " ") }}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            style="width: 12rem"
            class="customMultiselectCommon mr-2"
            v-if="platformList"
          >
            <div
              class="mb-1 ml-1"
              style="font-size: 14px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Category"][selectedLanguage.key] }}
            </div>
            <!-- <select class="form-control text-capitalize" v-model="selectedSegmentTrendlineModal"
              @change="processModalProductListOfSegment()">
              <option value="all" class="text-capitalize">All</option>
              <option v-for="(option, i) in viewModalSegmentData" :key="option + i + 'sp2'" :value="option"
                class="text-capitalize">
                {{ option.replaceAll("_", " ") }}
              </option>
            </select> -->
            <multiselect
              @input="processModalProductListOfSegment()"
              v-model="selectedSegmentTrendlineModal"
              :options="[
                getAllCategoryforAllKeyOption(),
                ...viewModalSegmentData,
              ]"
              :multiple="false"
              :searchable="false"
              label="value"
              track-by="key"
              placeholder="Select Category"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="text-capitalize"
            >
              <template #option="{ option }">
                <div class="custom-option text-capitalize">
                  <span>{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="custom_dropdown customMultiselectCommon"
            style="width: 15rem"
          >
            <div
              class="mb-1 ml-1"
              style="font-size: 14px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Product"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedProductTrendlineModal"
              track-by="key"
              label="value"
              :options="viewModalProductList"
              :multiple="false"
              :placeholder="
                translatedLang['Search Product'][selectedLanguage.key]
              "
              select-label=""
              deselect-label=""
              selectedLabel=""
              :closeOnSelect="true"
              @input="getModalTrendlineGraphData()"
            >
              <template #option="{ option }">
                <div class="custom-option text-capitalize" :title="option">
                  <span>{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <div v-if="getKeyForAvailabilityPincode">
            <div
              class="ml-2 customMultiselect"
              style="width: 14rem"
              v-if="viewPinListModalTrendLine"
            >
              <!-- <multiselect v-model="selectedPinTrendLineModal" :options="viewPinListModalTrendLine" :multiple="true"
              group-values="pins" group-label="City" :group-select="true" placeholder="Type pin" track-by="pin"
              label="pin" selectGroupLabel="Press enter to select city" @input="getModalTrendlineGraphData()"><span
                slot="noResult">Oops! No elements found. Consider changing the search query.</span></multiselect> -->
              <div
                class="mb-1 ml-1"
                style="font-size: 14px; font-weight: 400; color: #1e1e1e"
              >
                {{ translatedLang["Pincode"][selectedLanguage.key] }}
              </div>
              <treeselect
                v-model="selectedPinTrendLineModal"
                limit="1"
                :options="viewPinListModalTrendLine"
                value-consists-of="LEAF_PRIORITY"
                :disable-branch-nodes="false"
                :placeholder="
                  translatedLang['Select PIN'][selectedLanguage.key]
                "
                :multiple="true"
                @input="getModalTrendlineGraphData()"
                :searchable="true"
                @select="handleSelectTrendLineModalPinChange"
              >
                <span slot="noResult">{{
                  translatedLang["No elements found"][selectedLanguage.key]
                }}</span>
              </treeselect>
            </div>
          </div>
        </div>
        <div
          v-if="
            procedModalTrandLineData.xAxis.length &&
            availabilityPinCodeModalDataShow
          "
          class="mt-2"
        >
          <lineChart
            :data="procedModalTrandLineData"
            :chartId="selectedSegmentTrendlineModal.key"
          />
        </div>
        <div
          v-else-if="!availabilityPinCodeModalDataShow && loader"
          class="onLoadingData mt-2"
        >
          {{ translatedLang["Loading"][selectedLanguage.key] }}...
        </div>
        <div
          v-else
          class="mt-2 text-danger d-flex justify-content-center border border-danger rounded p-2"
        >
          {{ translatedLang["No Data"][selectedLanguage.key] }}!
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";
import pinList from "./pinList.json";
import lineChart from "../commonCharts/lineChart.vue";
import indiaMap from "../commonCharts/IndiaMap.vue";
import pieChart from "../commonCharts/pieChart.vue";
import StateMapper from "../commonCharts/IndiaState.json";
import { all } from "q";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Loader from "../Components/Loader.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "indiagateDashboard",
  components: {
    Datepicker,
    Multiselect,
    lineChart,
    indiaMap,
    pieChart,
    Treeselect,
    Loader,
  },
  data: function () {
    return {
      loader0: false,
      loader: true,
      loader1: true,
      loader2: true,
      loader3: false,
      loader4: false,
      loader5: false,
      loader6: false,
      loader7: false,
      loader8: true,
      showModal: false,
      dateRange: {
        startDate: moment().subtract(1, "weeks").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      tableDateRangeMax: "",
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      tableDateRangeMin: "",
      tableDataRangeMax: "",
      tableModalDateRangeMin: "",
      tableModalDataRangeMax: "",
      trendlineModalDateRange: {
        startDate: moment().subtract(1, "weeks").format("YYYY-MM-DD"),
        endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      },
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map["Availability_Tracking"],
      isExportButton: JSON.parse(localStorage.reviewUserData).data.is_excel,
      // date: new Date(moment().subtract(1, "day")),
      date: {
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      },
      locationDropdown: {
        options: "",
        checkSelectedPins: [],
        selectedPin: [],
      },
      segmentDropdown: {
        options: [],
        selectedSegment: this.getAllCategoryforEmptyKeyOption(),
        isSegment: "",
        selectedProduct: "",
        productList: "",
        productFilterList: [],
      },
      mainTableData: {
        header: [
          { key: "product_name", value: "Product Name" },
          { key: "amazon", value: "Amazon" },
          { key: "flipkart", value: "Flipkart" },
        ],
        data: [],
      },
      modalData: {
        heading: "",
        tableHeader: [
          { key: "location_name", value: "Location" },
          { key: "pincode", value: "Pincodes" },
        ],
        tableData: [
          { location: "Delhi", pincode: ["110059", "110071", "110067"] },
          { location: "Noida", pincode: ["56656", "54546", "12354"] },
        ],
      },
      colorMapping: {
        red: "rgba(255, 211, 211, 1)",
        yellow: "rgba(255, 242, 194, 1)",
        green: "#CAFFD1",
        blue: "rgba(194, 195, 255, 1)",
      },
      isDropdown: false,
      isSelectedSegment: true,
      viewProductList: [],
      platformList: ["Amazon", "Flipkart"],
      viewTrendLineData: "",
      procedTrandLineData: { xAxis: [] },
      viewSegmentPlatformAndProductData: "",
      viewPlatformList: "",
      viewSegmentData: "",
      viewProductList: "",
      selectedTrendLinePlatform: "",
      tempSelectedTrendLinePlatform: "",
      selectedSegementForTrendline: this.getAllCategoryforAllKeyOption(),
      selectedProductListForTrendline: "",
      viewIndiaMapData: "",
      procedIndiaMapData: [],
      indiaStateMapper: StateMapper,
      showTrendLineModal: false,
      viewPieChartData: "",
      procesedPieChartData: [],
      viewPinListTrendLine: "",
      selectedPinForTrendLine: [],
      loaderStatus: false,
      storeAllDataForStatus: {},

      // Trend line modal section start
      viewModalSegmentData: [],
      viewModalProductList: "",
      viewModalTrendLineData: "",
      viewPinListModalTrendLine: "",
      procedModalTrandLineData: { xAxis: [] },
      selectedPlatformTrendlineModal: "",
      selectedSegmentTrendlineModal: this.getAllCategoryforAllKeyOption(),
      selectedProductTrendlineModal: "",
      selectedPinTrendLineModal: [],
      lastUpdated: `${moment().format("YYYY-MM-DD")} 11:00 AM`,
      //   selectedPlatform: "",
      // Trend line modal section end
      viewLastUpdatedData: "",
      pieChartAvailabilityDataShow: false,
      indiaMapAvailabilityDataShow: false,
      availabilityTrendDataShow: false,
      availabilityTableDataShow: false,
      availabilityPinCodeModalDataShow: false,
      getKeyForAvailabilityPincode: JSON.parse(localStorage.reviewUserData).data
        .pincode_avaliable,
      showNoDataImgForUser: false,
      storecategoryMap: [],
      lossBuyboxTableDateRange: {
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      minDateTableDateRange: "",
      maxDateTableDateRange: "",
      selectedPlatform: [],
      platformList: [],
      selectedTableCategory: [],
      categoryList: [],
      categoryTableList: "",
      selectedTableSubCategory: [],
      finalSelectedCategory: [],
      finalSelectedPincodeProductCategory: [],
      subCategoryList: [],
      lossSelectedBrand: [],
      lossBrandList: [],
      lossSelectedProduct: [],
      lossProductList: [],
      lossSelectedPIN: [],
      lossPINList: [],
      lossSelectedBatch: [],
      lossBatchList: [],
      selectedPincodeProductPlatform: [],
      selectedPincodeProductTableCategory: [],
      selectedPincodeProductTableSubCategory: [],
      lossSelectedPincodeProductBrand: [],
      lossSelectedPincodeProductId: [],
      lossSelectedPincodeProductPIN: [],
      pincodeProductSubCategoryList: [],
      lossPincodeProductPINList: [],
      pincodeProductCategoryList: [],
      lossSelectedPincodeProductBatch: [],
      sovInterval: "day",
      previousSelection: [],
      pincodeProductPlatformList: [],
      pincodeProductBrandList: [],
      previousCategorySelection: [],
      previousSubCategorySelection: [],
      previousPincodeProductCategorySelection: [],
      previousPincodeProductSubCategorySelection: [],
      previousBrandSelection: [],
      previousPincodeProductBrandSelection: [],
      previousProductSelection: [],
    };
  },
  created() {
    window.addEventListener("click", this.close);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.close);
  },
  mounted() {
    this.init();
  },
  watch: {
    sovInterval: function () {
      this.getTrendlineGraphData();
    },
    lossBuyboxTableDateRange: {
      handler() {
        this.getAllStatusByApi();
      },
      deep: true,
      // immediate: true
    },
    selectedSegementForTrendline: function () {
      if (
        Object.keys(this.storeAllDataForStatus).length &&
        this.selectedTrendLinePlatform.key !== "" &&
        this.selectedSegementForTrendline.key !== "all"
      ) {
        this.$store.dispatch(
          "DemoStore/setUpdatedStatus",
          this.storeAllDataForStatus[
            this.selectedTrendLinePlatform.key.toLowerCase()
          ][this.selectedSegementForTrendline.key]
        );
      } else {
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");
      }
    },
    selectedTableCategory(newVal) {
      let mergedChildren = [];
      newVal.forEach((cat) => {
        if (cat.child && Array.isArray(cat.child)) {
          mergedChildren.push(...cat.child);
        }
      });
      this.subCategoryList = mergedChildren;
      if (this.selectedTableCategory?.length && this.subCategoryList.length) {
        this.subCategoryList.unshift({
          key: "All",
          value: "All",
        });
      }
      const validKeys = new Set(mergedChildren.map((c) => c.key));
      this.selectedTableSubCategory = this.selectedTableSubCategory.filter(
        (subcat) => validKeys.has(subcat.key)
      );
      this.selectedTableSubCategory = this.subCategoryList;
      this.previousSubCategorySelection = [...this.selectedTableSubCategory];

      // this.selectedTableSubCategory = mergedChildren.length
      //   ? [mergedChildren[0]]
      //   : [];
    },
    // selectedPincodeProductTableCategory(newVal) {
    //   let mergedChildren = [];
    //   newVal.forEach((cat) => {
    //     if (cat.child && Array.isArray(cat.child)) {
    //       mergedChildren.push(...cat.child);
    //     }
    //   });
    //   this.pincodeProductSubCategoryList = mergedChildren;
    //   if (
    //     this.selectedPincodeProductTableCategory?.length &&
    //     this.pincodeProductSubCategoryList.length
    //   ) {
    //     this.pincodeProductSubCategoryList.unshift({
    //       key: "All",
    //       value: "All",
    //     });
    //   }
    //   // const pincodeProductCatKeys = new Set(mergedChildren.map((c) => c.key));
    //   this.selectedPincodeProductTableSubCategory =
    //     this.pincodeProductSubCategoryList;
    //   this.previousPincodeProductSubCategorySelection = [
    //     ...this.selectedPincodeProductTableSubCategory,
    //   ];
    //   // this.selectedPincodeProductTableSubCategory = mergedChildren.length
    //   //   ? [mergedChildren[0]]
    //   //   : [];
    // },
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    copyToClipboard(value) {
      window.navigator.clipboard.writeText(value);
      this.$bvToast.toast(`Copied ${value} to clipboard`, {
        title: "Weavr Sense",
        variant: "success",
        toaster: "b-toaster-top-right",
        autoHideDelay: 3000,
      });
    },

    init() {
      this.formatDates();
      // this.getTableData();
      this.getSegmentListData();
      this.getPinListData();
      this.getPinListForTrendLine();
      this.getLastUpdatedDates();
      // this.getSegmentWiseProductListData();
      // this.getStateWiseData();
      // this.getPieChartData();
      // this.handleExportFilter()
    },
    // treeselect select code 
    handleSelectTrendLineModalPinChange(newVal) {
      const selectedValue = [newVal]
      if(selectedValue.some((data)=>data.label==='All')){
        if(this.selectedPinTrendLineModal.length>=1){
          // console.log("inside if")
          this.$nextTick(() => {
            this.selectedPinTrendLineModal =['all'];
          });
        }
      }
      else if(selectedValue.some((data)=>data.label!=='All')){
        this.$nextTick(() => {
          this.selectedPinTrendLineModal = this.selectedPinTrendLineModal.filter((val) => val !=='all');
        });
      }
    },
    handleSelectProductPinChange(newVal) {
      const selectedValue = [newVal]
      if(selectedValue.some((data)=>data.label==='All')){
        if(this.lossSelectedPincodeProductPIN.length>=1){
          // console.log("inside if")
          this.$nextTick(() => {
            this.lossSelectedPincodeProductPIN =['all'];
          });
        }
      }
      else if(selectedValue.some((data)=>data.label!=='All')){
        this.$nextTick(() => {
          this.lossSelectedPincodeProductPIN = this.lossSelectedPincodeProductPIN.filter((val) => val !=='all');
        });
      }
    },
    handleSelectTopFilterPinChange(newVal) {
      const selectedValue = [newVal]
      if(selectedValue.some((data)=>data.label==='All')){
        if(this.lossSelectedPIN.length>=1){
          // console.log("inside if")
          this.$nextTick(() => {
            this.lossSelectedPIN =['all'];
          });
        }
      }
      else if(selectedValue.some((data)=>data.label!=='All')){
        this.$nextTick(() => {
          this.lossSelectedPIN = this.lossSelectedPIN.filter((val) => val !=='all');
        });
      }
    },
    changeTableCategory() {
      if (this.selectedPlatform) {
        this.selectedTableCategory = [];
        this.lossSelectedBrand = [];
        this.lossSelectedPIN = [];
        this.categoryList = this.allCategory[this.selectedPlatform?.key];
        this.previousCategorySelection = [...this.categoryList];
        const hasAll = this.categoryList.some((item) => item.key === "All");
        if (!hasAll) {
          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });
        }

        this.subCategoryList = this.categoryList[0].child;

        this.lossPINList = this.allPincodeList[this.selectedPlatform?.key];
        this.handleChangeCategory();
      }
    },
    handlePlatformSelection(selected) {
      const otherOptions = this.pincodeProductPlatformList.filter(
        (p) => p.key !== "All"
      );

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSelection.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedPincodeProductPlatform = [
          ...this.pincodeProductPlatformList,
        ];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedPincodeProductPlatform = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedPincodeProductPlatform = [
            ...this.pincodeProductPlatformList,
          ];
        } else {
          this.selectedPincodeProductPlatform = [...selectedWithoutAll];
        }
      }

      this.previousSelection = [...this.selectedPincodeProductPlatform];

      this.changePincodeProductTableCategory();
    },
    changePincodeProductTableCategory() {
      if (this.selectedPincodeProductPlatform?.length) {
        this.selectedPincodeProductTableCategory = [];
        this.lossSelectedPincodeProductBrand = [];
        this.lossSelectedPincodeProductId = [];
        this.lossSelectedPincodeProductPIN = [];

        const categoryMap = new Map();
        this.pincodeProductCategoryList = [];
        this.pincodeProductSubCategoryList = [];

        this.selectedPincodeProductPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const categories = this.allCategory[platformKey];

          if (categories?.length) {
            categories.forEach((cat) => {
              if (!categoryMap.has(cat.key)) {
                categoryMap.set(cat.key, cat);
                this.pincodeProductCategoryList.push(cat);
              }
            });
          }
        });
        if (this.selectedPincodeProductPlatform.length) {
          this.pincodeProductCategoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });
        }
        const stateMap = new Map();

        this.selectedPincodeProductPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const states = this.allPincodeList[platformKey] || [];

          states.forEach((state) => {
            if (!stateMap.has(state.id)) {
              stateMap.set(state.id, {
                id: state.id,
                label: state.label,
                children: [],
              });
            }

            const stateEntry = stateMap.get(state.id);
            const cityMap = new Map(
              stateEntry.children.map((city) => [city.id, city])
            );

            state.children?.forEach((city) => {
              if (!cityMap.has(city.id)) {
                cityMap.set(city.id, {
                  id: city.id,
                  label: city.label,
                  children: [],
                });
              }

              const cityEntry = cityMap.get(city.id);
              const pinMap = new Map(
                cityEntry.children.map((pin) => [pin.id, pin])
              );

              city.children?.forEach((pin) => {
                if (!pinMap.has(pin.id)) {
                  pinMap.set(pin.id, {
                    id: pin.id,
                    label: pin.label,
                  });
                }
              });

              cityEntry.children = Array.from(pinMap.values());
            });

            stateEntry.children = Array.from(cityMap.values());
          });
        });

        this.lossPincodeProductPINList = Array.from(stateMap.values());
      } else {
        this.selectedPincodeProductTableCategory = [];
        this.pincodeProductCategoryList = [];
      }
      this.handleChangePincodeProductCategory();
    },

    handleChangeCategory(selected) {
      if (!this.selectedTableCategory?.length) {
        this.selectedTableSubCategory = [];
      }
      const otherOptions = this.categoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedTableCategory = [...this.categoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedTableCategory = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedTableCategory = [...this.categoryList];
        } else {
          this.selectedTableCategory = [...selectedWithoutAll];
        }
      }

      this.previousCategorySelection = [...this.selectedTableCategory];
      this.getBrandData(false);
      this.handleChangeSubCategory();
    },
    handleChangeSubCategory(selected) {
      if (!this.selectedTableCategory?.length) {
        this.selectedTableSubCategory = [];
      } else {
        const otherOptions = this.subCategoryList.filter(
          (p) => p.key !== "All"
        );

        const isAllCurrentlySelected = selected.some(
          (opt) => opt.key === "All"
        );
        const wasAllPreviouslySelected =
          this.previousSubCategorySelection?.some((opt) => opt.key === "All");

        if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
          this.selectedTableSubCategory = [...this.subCategoryList];
        } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
          this.selectedTableSubCategory = [];
        } else {
          const selectedWithoutAll = selected.filter(
            (opt) => opt.key !== "All"
          );
          if (selectedWithoutAll.length === otherOptions.length) {
            this.selectedTableSubCategory = [...this.subCategoryList];
          } else {
            this.selectedTableSubCategory = [...selectedWithoutAll];
          }
        }

        this.previousSubCategorySelection = [...this.selectedTableSubCategory];
      }

      this.$nextTick(() => {
        this.getBrandData(false);
      });
    },
    handleChangePincodeProductCategory(selected) {
      if (!selected?.length) {
        this.selectedPincodeProductTableSubCategory = [];
      }

      const otherOptions = this.pincodeProductCategoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected?.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousPincodeProductCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedPincodeProductTableCategory = [...this.pincodeProductCategoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedPincodeProductTableCategory = [];
      } else {
        const selectedWithoutAll = selected?.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedPincodeProductTableCategory = [...this.pincodeProductCategoryList];
        } else {
          this.selectedPincodeProductTableCategory = [...selectedWithoutAll];
        }
      }

      this.previousPincodeProductCategorySelection = [...this.selectedPincodeProductTableCategory];

      // this.$nextTick(() => {
      this.getPincodeProductBrandData(false);
      // });
    },
    handleChangePincodeProductSubCategory(selected) {
      if (!this.selectedPincodeProductTableCategory.length) {
        this.selectedPincodeProductTableSubCategory = [];
      } else {
        const otherOptions = this.pincodeProductSubCategoryList.filter(
          (p) => p.key !== "All"
        );

        const isAllCurrentlySelected = selected.some(
          (opt) => opt.key === "All"
        );
        const wasAllPreviouslySelected =
          this.previousPincodeProductSubCategorySelection?.some(
            (opt) => opt.key === "All"
          );

        if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
          this.selectedPincodeProductTableSubCategory = [
            ...this.pincodeProductSubCategoryList,
          ];
        } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
          this.selectedPincodeProductTableSubCategory = [];
        } else {
          const selectedWithoutAll = selected.filter(
            (opt) => opt.key !== "All"
          );
          if (selectedWithoutAll.length === otherOptions.length) {
            this.selectedPincodeProductTableSubCategory = [
              ...this.pincodeProductSubCategoryList,
            ];
          } else {
            this.selectedPincodeProductTableSubCategory = [
              ...selectedWithoutAll,
            ];
          }
        }

        this.previousPincodeProductSubCategorySelection = [
          ...this.selectedPincodeProductTableSubCategory,
        ];
      }

      this.$nextTick(() => {
        this.getPincodeProductBrandData(false);
      });
    },
    handleBrand(selected) {
      const otherOptions = this.lossBrandList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousBrandSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedBrand = [...this.lossBrandList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedBrand = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedBrand = [...this.lossBrandList];
        } else {
          this.lossSelectedBrand = [...selectedWithoutAll];
        }
      }

      this.previousBrandSelection = [...this.lossSelectedBrand];
      // this.getProductIdData();
    },
    handlePincodeProductBrand(selected) {
      const otherOptions = this.pincodeProductBrandList.filter(
        (p) => p.key !== "All"
      );

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected =
        this.previousPincodeProductBrandSelection?.some(
          (opt) => opt.key === "All"
        );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedPincodeProductBrand = [
          ...this.pincodeProductBrandList,
        ];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedPincodeProductBrand = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedPincodeProductBrand = [
            ...this.pincodeProductBrandList,
          ];
        } else {
          this.lossSelectedPincodeProductBrand = [...selectedWithoutAll];
        }
      }

      this.previousPincodeProductBrandSelection = [
        ...this.lossSelectedPincodeProductBrand,
      ];
      this.getPincodeProductIdData();
    },
    handleProductIdSelection(selected) {
      const otherOptions = this.lossProductList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousProductSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedPincodeProductId = [...this.lossProductList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedPincodeProductId = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedPincodeProductId = [...this.lossProductList];
        } else {
          this.lossSelectedPincodeProductId = [...selectedWithoutAll];
        }
      }

      this.previousProductSelection = [...this.lossSelectedPincodeProductId];
    },
    handleApplyFilters() {
      //   this.getTableData();
    },
    getFiltersData(isMounted) {
      let self = this;
      self.vocProductListLoader = true;
      const url = "/api/v2/product/filter_data";
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          this.platformList = [...response.data.data.platform];
          this.pincodeProductPlatformList = [...response.data.data.platform];
          this.selectedPlatform = this.platformList[0];
          this.pincodeProductPlatformList.unshift({ key: "All", value: "All" });
          this.selectedPincodeProductPlatform = [
            ...this.pincodeProductPlatformList,
          ];
          this.previousSelection = [...this.selectedPincodeProductPlatform];
          this.allCategory = response.data.data.category;
          this.categoryList =
            response.data.data.category[
              this.selectedPlatform.key || this.selectedPlatform[0].key
            ] || [];
          this.categoryList = JSON.parse(JSON.stringify(this.categoryList));
          if (this.categoryList.length) {
            this.categoryList.unshift({
              key: "All",
              value: "All",
              child: [],
            });
          }
          // this.subCategoryList.unsify
          this.selectedTableCategory = this.categoryList;
          this.previousCategorySelection = [...this.selectedTableCategory];

          this.pincodeProductCategoryList = [];
          this.pincodeProductSubCategoryList = [];
          
          const categoryMap = new Map();
          const subCategoryMap = new Map();
          this.pincodeProductCategoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });
          this.pincodeProductSubCategoryList.unshift({
            key: "All",
            value: "All",
          });
          this.pincodeProductPlatformList.forEach((platform) => {
            const platformKey = platform.key;
            const categories = this.allCategory[platformKey];

            if (categories?.length) {
              categories.forEach((cat) => {
                if (!categoryMap.has(cat.key)) {
                  categoryMap.set(cat.key, cat);
                  this.pincodeProductCategoryList.push(cat);
                }
                cat.child.forEach((sub) => {
                  if (!subCategoryMap.has(sub.key)) {
                    subCategoryMap.set(sub.key, sub);
                    this.pincodeProductSubCategoryList.push(sub);
                  }
                });
              });
            }
          });

          this.selectedPincodeProductTableCategory =
            this.pincodeProductCategoryList;
          this.previousPincodeProductCategorySelection = [
            ...this.selectedPincodeProductTableCategory,
          ];
          this.selectedPincodeProductTableSubCategory =
            this.pincodeProductSubCategoryList;
          this.previousPincodeProductSubCategorySelection = [
            ...this.selectedPincodeProductTableSubCategory,
          ];
          this.lossPINList =
            response.data.data.pincode[
              this.selectedPlatform.key || this.selectedPlatform[0].key
            ];

          this.lossSelectedPIN =
            this.lossPINList?.[1]?.children?.[0]?.children?.map(
              (pin) => pin.id
            ) || [];

          const selectedPlatforms = Array.isArray(
            this.selectedPincodeProductPlatform
          )
            ? this.selectedPincodeProductPlatform
            : [this.selectedPincodeProductPlatform];

          const stateMap = new Map();

          selectedPlatforms.forEach((platform) => {
            const platformKey = platform.key;
            const states = response.data.data.pincode[platformKey] || [];

            states.forEach((state) => {
              if (!stateMap.has(state.id)) {
                stateMap.set(state.id, {
                  id: state.id,
                  label: state.label,
                  children: [],
                });
              }

              const stateEntry = stateMap.get(state.id);
              const cityMap = new Map(
                stateEntry.children.map((city) => [city.id, city])
              );

              state.children?.forEach((city) => {
                if (!cityMap.has(city.id)) {
                  cityMap.set(city.id, {
                    id: city.id,
                    label: city.label,
                    children: [],
                  });
                }

                const cityEntry = cityMap.get(city.id);
                const pinMap = new Map(
                  cityEntry.children.map((pin) => [pin.id, pin])
                );

                city.children?.forEach((pin) => {
                  if (!pinMap.has(pin.id)) {
                    pinMap.set(pin.id, {
                      id: pin.id,
                      label: pin.label,
                    });
                  }
                });

                cityEntry.children = Array.from(pinMap.values());
              });

              stateEntry.children = Array.from(cityMap.values());
            });
          });

          this.lossPincodeProductPINList = Array.from(stateMap.values());
          this.lossSelectedPincodeProductPIN =
            this.lossPincodeProductPINList[1]?.children[0]?.children.map(
              (data) => data.id
            );

          this.allPincodeList = response.data.data.pincode;
          this.lossBatchList =
            response.data.data.batch["availability tracking"];
          this.lossSelectedBatch = this.lossBatchList[0];
          this.lossSelectedPincodeProductBatch = this.lossBatchList[0];
          this.batchList = response.data.data.batch["availability tracking"];
          this.getPincodeProductBrandData(isMounted).then(() => {
            this.getBrandData(isMounted);
            this.getPieChartData();
            this.getStateWiseData();
            this.getTableData();
            this.getTrendlineGraphData();
          });
          self.vocProductListLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },
    async getBrandData(isMounted) {
      const url = "/api/v2/brand/data";
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((subcat) => subcat.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform?.key || this.selectedPlatform[0].key,
        category: this.finalSelectedCategory,
        // product: [],
        pincode: this.lossSelectedPIN?.length ? this.lossSelectedPIN : [],
        feature_id: this.featureId,
      };
      try {
        const res = await this.$http.post(url, payload);
        this.lossBrandList = res.data.data;
        if (this.lossBrandList.length) {
          this.lossBrandList.unshift({ key: "All", value: "All" });
        }
        this.lossSelectedBrand = this.lossBrandList;
        this.$nextTick(() => {
          this.previousBrandSelection = [...this.lossSelectedBrand];
        });
        //   this.lossSelectedBrand = [this.lossBrandList[0]];
        // return this.getProductIdData(isMounted);
      } catch (err) {
        console.error(err);
      }
    },

    // getProductIdData(isMounted) {
    //   const url = "/api/v2/product/data";
    //   if (this.selectedTableSubCategory.length) {
    //     this.finalSelectedCategory = this.selectedTableSubCategory
    //       ?.filter((subcat) => subcat.key !== "All")
    //       .map((subcat) => subcat.key);
    //   } else if (
    //     !this.selectedTableSubCategory.length &&
    //     this.selectedTableCategory.length
    //   ) {
    //     this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
    //       (data) => {
    //         return data.child?.map((subcat) => subcat.key);
    //       }
    //     );
    //   } else {
    //     this.finalSelectedCategory = [];
    //   }
    //   let payload = {
    //     start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
    //       "YYYY-MM-DD"
    //     ),
    //     end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
    //       "YYYY-MM-DD"
    //     ),
    //     language: this.$store.state.DemoStore.selectedLanguage.key,
    //     channel: this.selectedPlatform?.key || this.selectedPlatform[0].key,
    //     // category: ["9c1c49eef3a2414c8e59b6e177c7ba1c"],
    //     category: this.finalSelectedCategory,
    //     brand: this.lossSelectedBrand?.length
    //       ? this.lossSelectedBrand
    //           ?.filter((p) => p.key !== "All")
    //           ?.map((brand) => brand.key)
    //       : [],
    //   };
    //   this.$http
    //     .post(url, payload)
    //     .then((res) => {
    //       this.lossProductList = res.data.data;

    //       //   this.lossSelectedProduct = [this.lossProductList[0]];
    //       if (isMounted) {
    //         this.getPieChartData();
    //         this.getStateWiseData();
    //       }
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    // },
    async getPincodeProductBrandData(isMounted) {
      const url = "/api/v2/brand/data";
      if (this.selectedPincodeProductTableSubCategory.length) {
        this.finalSelectedPincodeProductCategory =
          this.selectedPincodeProductTableSubCategory
            ?.filter((subcat) => subcat.key !== "All")
            .map((subcat) => subcat.key);
      } else if (
        !this.selectedPincodeProductTableSubCategory.length &&
        this.selectedPincodeProductTableCategory.length
      ) {
        this.finalSelectedPincodeProductCategory =
          this.selectedPincodeProductTableCategory?.flatMap((data) => {
            return data.child?.map((subcat) => subcat.key);
          });
      } else {
        this.finalSelectedPincodeProductCategory = [];
      }
      let payload = {
        start_date: moment(this.date.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.date.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPincodeProductPlatform
          ?.filter((platform) => platform.key != "All")
          ?.map((platform) => platform.key),
        category: this.finalSelectedPincodeProductCategory,
        // product: [],
        pincode: this.lossSelectedPincodeProductPIN?.length
          ? this.lossSelectedPincodeProductPIN
          : [],
        feature_id: this.featureId,
      };
      try {
        const res = await this.$http.post(url, payload);
        this.pincodeProductBrandList = res.data.data;
        if (this.pincodeProductBrandList.length) {
          this.pincodeProductBrandList.unshift({ key: "All", value: "All" });
        }
        this.lossSelectedPincodeProductBrand = this.pincodeProductBrandList;
        this.previousPincodeProductBrandSelection = [
          ...this.lossSelectedPincodeProductBrand,
        ];
        await this.getPincodeProductIdData(isMounted);
      } catch (err) {
        console.error(err);
      }
    },
    async getPincodeProductIdData(isMounted) {
      const url = "/api/v2/product/data";
      if (this.selectedPincodeProductTableSubCategory.length) {
        this.finalSelectedPincodeProductCategory =
          this.selectedPincodeProductTableSubCategory
            ?.filter((subcat) => subcat.key !== "All")
            .map((subcat) => subcat.key);
      } else if (
        !this.selectedPincodeProductTableSubCategory.length &&
        this.selectedPincodeProductTableCategory.length
      ) {
        this.finalSelectedPincodeProductCategory =
          this.selectedPincodeProductTableCategory?.flatMap((data) => {
            return data.child?.map((subcat) => subcat.key);
          });
      } else {
        this.finalSelectedPincodeProductCategory = [];
      }
      let payload = {
        start_date: moment(this.date.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.date.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPincodeProductPlatform
          ?.filter((platform) => platform.key != "All")
          ?.map((platform) => platform.key),
        category: this.finalSelectedPincodeProductCategory,
        brand: this.lossSelectedPincodeProductBrand?.length
          ? this.lossSelectedPincodeProductBrand
              ?.filter((brand) => brand.key !== "All")
              .map((brand) => brand.key)
          : [],
        feature_id: this.featureId,
      };
      try {
        const res = await this.$http.post(url, payload);
        this.lossProductList = res.data.data;
        if (this.lossProductList.length) {
          this.lossProductList.unshift({ key: "All", value: "All" });
        }
        this.lossSelectedPincodeProductId = this.lossProductList;
        this.previousProductSelection = [...this.lossSelectedPincodeProductId];
        // if (isMounted) this.getTableData();
      } catch (err) {
        console.error(err);
      }
    },
    toggleDropdown() {
      if (this.isDropdown) {
        this.isDropdown = false;
      } else {
        this.isDropdown = true;
      }
    },
    handleDateChange() {
      this.getPinListData();
    },
    // changePlatform() {
    // 	this.viewSegmentData = Object.keys(this.viewSegmentPlatformAndProductData[this.selectedTrendLinePlatform])
    // 	if (this.viewSegmentData.includes(this.selectedSegementForTrendline.key)) {
    // 		this.selectedSegementForTrendline = this.selectedSegementForTrendline
    // 	}
    // 	else {
    // 		this.selectedSegementForTrendline = { key: 'all', value: 'All Categories' }
    // 	}
    // 	this.setPlatformWiseData(false);
    // 	if (Object.keys(this.storeAllDataForStatus).length && this.selectedTrendLinePlatform !== '' && this.selectedSegementForTrendline.key !== 'all') {
    // 		this.$store.dispatch("DemoStore/setUpdatedStatus", this.storeAllDataForStatus[this.selectedTrendLinePlatform.toLowerCase()][this.selectedSegementForTrendline.key])
    // 	} else {
    // 		this.$store.dispatch("DemoStore/setUpdatedStatus", '')
    // 	}
    // },
    changePlatform() {
      let segments = Object.keys(
        this.viewSegmentPlatformAndProductData[
          this.selectedTrendLinePlatform.key
        ]
      );
      this.viewSegmentData = segments.map((segmentKey) => {
        const mappedCategory = this.storecategoryMap.find(
          (category) => category.key === segmentKey
        );
        return {
          key: segmentKey,
          value: mappedCategory
            ? mappedCategory.value
            : segmentKey.replace(/_/g, " "),
        };
      });

      if (
        this.viewSegmentData.some(
          (segment) => segment.key === this.selectedSegementForTrendline.key
        )
      ) {
        this.selectedSegementForTrendline = this.selectedSegementForTrendline;
      } else {
        this.selectedSegementForTrendline =
          this.getAllCategoryforAllKeyOption();
      }

      this.setPlatformWiseData(false);

      if (
        Object.keys(this.storeAllDataForStatus).length &&
        this.selectedTrendLinePlatform.key !== "" &&
        this.selectedSegementForTrendline.key !== "all"
      ) {
        this.$store.dispatch(
          "DemoStore/setUpdatedStatus",
          this.storeAllDataForStatus[
            this.selectedTrendLinePlatform.key.toLowerCase()
          ][this.selectedSegementForTrendline.key]
        );
      } else {
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");
      }
    },
    filterApply() {
      this.pieChartAvailabilityDataShow = false;
      this.indiaMapAvailabilityDataShow = false;
    // this.availabilityTrendDataShow = false;

      this.tempSelectedTrendLinePlatform = this.selectedTrendLinePlatform;
      this.dateChangeTrendLineAndMap();
      this.processSegmentData();
      this.processProductListOfSegment();
    },
    handleExportFilter() {
      if ($.fn.DataTable.isDataTable("#indiagate-dashboard-table")) {
        $("#indiagate-dashboard-table").DataTable().clear().destroy();
      }
      this.availabilityTableDataShow = false;
      this.isSelectedSegment = false;
      this.processSelectedPin();
      this.formatDates();
    },
    close(event) {
      if (event.target) {
        if (event.target == this.$refs.clrBtn) {
          return;
        } else this.isDropdown = false;
      }
    },

    updateSelectedLabels(option) {
      return option.value.replaceAll("_", " ");
    },
    getLastUpdatedDates(flag) {
      this.loader0 = true;

      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http.get(url).then(
        (response) => {
          // console.log(response.body.data.data.availability_matrix, 'ddd')
          if (response.body.data.availability_matrix) {
            localStorage.availability_matrix_last_update = JSON.stringify(
              response.body.data.availability_matrix
            );
            this.maxDateTableDateRange =
              response.body.data.availability_matrix.end_date;
            this.tableDateRangeMax =
              response.body.data.availability_matrix.end_date;
            this.lastUpdated = `${moment(
              response.body.data.availability_matrix.end_date
            ).format("DD MMM, YYYY")} ${
              response.body.data.availability_matrix.latest_time ? "at" : ""
            } ${response.body.data.availability_matrix.latest_time}`;
            this.lossBuyboxTableDateRange.endDate = moment(
              response.body.data.availability_matrix.end_date
            ).format("YYYY-MM-DD");
            this.lossBuyboxTableDateRange.startDate = moment(
              response.body.data.availability_matrix.end_date
            ).format("YYYY-MM-DD");
            this.date.endDate = moment(
              response.body.data.availability_matrix.end_date
            ).format("YYYY-MM-DD");
            this.date.startDate = moment(
              response.body.data.availability_matrix.end_date
            ).format("YYYY-MM-DD");
            this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
            //  this.getAllStatusByApi();
            this.getFiltersData();
            this.getSegmentWiseProductListData();
            this.loader0 = false;
            this.showNoDataImgForUser = false;
          } else {
            this.loader0 = false;
            this.loader = false;
            this.loader1 = false;
            this.loader2 = false;
            this.loader8 = false;
            this.showNoDataImgForUser = true;
          }
          // this.viewLastUpdatedData = response.body.data.data
          //   if (this.selectedTrendLinePlatform) {
          //     this.handlePlatformSelection();

          //   } else {
          //     this.dateRange.endDate = moment(response.body.data.availability_matrix.end_date).format("YYYY-MM-DD");
          //     this.dateRange.startDate = moment(response.body.data.availability_matrix.end_date).subtract(1, 'week').format("YYYY-MM-DD");
          //     // console.log(response.body, 'ddd')
          //     this.date.startDate = moment(response.body.data.availability_matrix.end_date).format("YYYY-MM-DD");
          //     this.date.endDate = moment(response.body.data.availability_matrix.end_date).format("YYYY-MM-DD");
          //     this.trendlineModalDateRange.startDate = moment(response.body.data.availability_matrix.end_date).subtract(1, 'week').format("YYYY-MM-DD");
          //     this.trendlineModalDateRange.endDate = moment(response.body.data.availability_matrix.end_date).format("YYYY-MM-DD");
          //     this.maxDate = new Date(response.body.data.availability_matrix.end_date);
          //     this.minDate = new Date(response.body.data.availability_matrix.start_date);
          //   }

          // }
          this.loader0 = false;
          // if (flag) {
          //   this.getTableData();
          // }
        },
        (err) => {
          this.loader0 = false;
        }
      );
    },

    getAllStatusByApi() {
      //   console.log('kpl')
      let self = this;
      self.loaderStatus = true;
      const url = "api/v2/sensespiderstatus";
      let payload = {
        // "client_id": "1e5b11d71bf84ee7ac584db27d458389",
        timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        feature: "pincode",
        feature_id: this.featureId,

      };
      self.$http
        .post(url, payload)
        .then((response) => {
          // self.storeAllDataForStatus = response.body.data;

          if (
            Object.keys(self.storeAllDataForStatus).length &&
            self.selectedPlatform.key !== "" &&
            self.selectedSegementForTrendline.key !== "all"
          ) {
            self.$store.dispatch(
              "DemoStore/setUpdatedStatus",
              self.storeAllDataForStatus[
                self.selectedPlatform.key.toLowerCase()
              ][self.selectedSegementForTrendline.key]
            );
          } else {
            self.$store.dispatch("DemoStore/setUpdatedStatus", "");
          }
          self.loaderStatus = false;
        })
        .catch((err) => {
          console.log(err);
          self.loaderStatus = false;
        });
    },

    setPlatformWiseData(flag) {
      if (localStorage.availability_matrix_last_update) {
        this.viewLastUpdatedData = JSON.parse(
          localStorage.availability_matrix_last_update
        );
        this.dateRange.endDate = moment(
          this.viewLastUpdatedData[this.selectedPlatform.key.toLowerCase()]
            .end_date
        ).format("YYYY-MM-DD");
        this.dateRange.startDate = moment(
          this.viewLastUpdatedData[this.selectedPlatform.key.toLowerCase()]
            .end_date
        )
          .subtract(1, "week")
          .format("YYYY-MM-DD");
        // console.log(response.body, 'ddd')
        if (flag) {
          this.date.startDate = moment(
            this.viewLastUpdatedData.end_date
          ).format("YYYY-MM-DD");
          this.date.endDate = moment(this.viewLastUpdatedData.end_date).format(
            "YYYY-MM-DD"
          );
          this.tableDateRangeMin = new Date(
            this.viewLastUpdatedData.start_date
          );
          this.tableDateRangeMax = new Date(this.viewLastUpdatedData.end_date);
        }

        this.maxDate = new Date(
          this.viewLastUpdatedData[
            this.selectedTrendLinePlatform.key.toLowerCase()
          ].end_date
        );
        this.minDate = new Date(
          this.viewLastUpdatedData[
            this.selectedTrendLinePlatform.key.toLowerCase()
          ].start_date
        );
        this.lastUpdated = `${moment(
          this.viewLastUpdatedData[
            this.selectedTrendLinePlatform.key.toLowerCase()
          ].end_date
        ).format("DD MMM, YYYY")} ${
          this.viewLastUpdatedData[
            this.selectedTrendLinePlatform.key.toLowerCase()
          ].latest_time
            ? "at"
            : ""
        } ${
          this.viewLastUpdatedData[
            this.selectedTrendLinePlatform.key.toLowerCase()
          ].latest_time
        }`;
        this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
      }
    },
    changeModalPlatform(isModal) {
      this.selectedSegmentTrendlineModal = this.getAllCategoryforAllKeyOption();
      this.trendlineModalDateRange.endDate = moment(
        this.viewLastUpdatedData[
          this.selectedPlatformTrendlineModal.key.toLowerCase()
        ].end_date
      ).format("YYYY-MM-DD");
      this.trendlineModalDateRange.startDate = moment(
        this.viewLastUpdatedData[
          this.selectedPlatformTrendlineModal.key.toLowerCase()
        ].end_date
      )
        .subtract(1, "week")
        .format("YYYY-MM-DD");
      this.tableModalDateRangeMin = moment(
        this.viewLastUpdatedData[
          this.selectedPlatformTrendlineModal.key.toLowerCase()
        ].start_date
      ).format("YYYY-MM-DD");
      this.tableModalDataRangeMax = moment(
        this.viewLastUpdatedData[
          this.selectedPlatformTrendlineModal.key.toLowerCase()
        ].end_date
      ).format("YYYY-MM-DD");
      this.processSegmentModalData(isModal);
    },

    // handlePlatformSelection() {
    // 	this.selectedTrendLinePlatform = this.viewPlatformList.find(
    // 		(website) => website === this.selectedTrendLinePlatform
    // 	);
    // },
    downloadStandardExel() {
      let self = this;
      this.loader = true;
      let payload = {
        data:{
          data: this.mainTableData.data,
          headers: this.mainTableData.unModifiedHeaderData,
        },
        feature_id: this.featureId,
      };
      const url = "/api/v2/indian_clients/pincode/availability_matrix_report_excel";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
        }
      );
    },

    downloadExel() {
      let self = this;
      this.loader = true;
      let payload = {
        timestamp: moment(this.date.startDate).format("YYYY-MM-DD"),
        client: this.client,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      const url = "/api/v2/india_clients/pincode_report";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
        }
      );
    },

    downloadLastExel() {
      let self = this;
      this.loader = true;
      let endData = moment().subtract(1, "days").format("YYYY-MM-DD");
      let payload = {
        start_date: moment(endData).subtract(2, "months").format("YYYY-MM-DD"),
        end_date: endData,
        client: this.client,
        feature_id: this.featureId,
      };
      if (this.isSegment) {
        payload.segment = [];
      }
      const url = "/api/v2/india_client/pincode_avaimonth_report";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
        }
      );
    },

    formatDates() {
      this.date.startDate = moment(this.date.startDate).format("YYYY-MM-DD");
      this.date.endDate = moment(this.date.endDate).format("YYYY-MM-DD");
      // this.dateRange.startDate = moment(this.dateRange.startDate).format('YYYY-MM-DD')
      // this.dateRange.endDate = moment(this.dateRange.endDate).format('YYYY-MM-DD')
    },
    dateChange() {
      this.trendlineModalDateRange.startDate = moment(this.date.startDate)
        .subtract(1, "weeks")
        .format("YYYY-MM-DD");
      this.trendlineModalDateRange.endDate = moment(this.date.startDate).format(
        "YYYY-MM-DD"
      );
      this.formatDates();
      this.getSegmentListData();
      this.getTableData();
      this.getPinListData();
    },

    dateChangeTrendLineAndMap() {
      this.getPinListForTrendLine();
      this.getTrendlineGraphData();
      this.getStateWiseData();
      this.getPieChartData();
    },

    dateChangeModalTrendLine() {
      this.getPinListForModalTrendLine();
      this.getModalTrendlineGraphData();
    },

    async getPieChartData() {
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((subcat) => subcat.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let self = this;
      this.loader = true;
      this.viewTrendLineData = "";
      this.procesedPieChartData = [];
      // this.loader = true;
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        platforms: [this.selectedPlatform?.key],
        category: this.finalSelectedCategory,
        pincode: this.lossSelectedPIN,
        batch: this.lossSelectedBatch?.batch,
        brand: this.lossSelectedBrand
          ?.filter((p) => p.key !== "All")
          ?.map((brand) => brand.key),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      if (this.selectedSegementForTrendline.key != "all") {
        payload.segment = this.selectedSegementForTrendline.key;
      }
      const url = "/api/v2/indian_clients/availability/chart";
      try {
        const res = await self.$http.post(url, payload);
        let data = res.data.data;
        if (data) {
          this.procesedPieChartData = [
            {
              name: `${
                this.translatedLang["Available"][this.selectedLanguage.key]
              }`,
              y: data.percentage_available,
              color: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 1,
                  y2: 1,
                },
                stops: [
                  [0, "rgba(1, 105, 92, 1)"],
                  [1, "rgba(0, 150, 136, 1)"],
                ],
              },
            },
            {
              name: `${
                this.translatedLang["Unavailable"][this.selectedLanguage.key]
              }`,
              y: data.percentage_non_available,
              color: "#d66772",
            },
          ];
        }
        self.pieChartAvailabilityDataShow = res.data.data_present;
        this.tempSelectedTrendLinePlatform = this.selectedPlatform;
        self.loader = false;
      } catch (err) {
        self.loader = false;
        self.pieChartAvailabilityDataShow = false;
        console.log("err");
      }
    },

    async getTrendlineGraphData() {
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((subcat) => subcat.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let self = this;
      this.loader1 = true;
      this.availabilityTrendDataShow = false;
      this.viewTrendLineData = "";
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format("YYYY-MM-DD"),
        platform: [this.selectedPlatform?.key],
        category: this.finalSelectedCategory,
        pincode: this.lossSelectedPIN,
        batch: this.lossSelectedBatch?.batch,
        brand: this.lossSelectedBrand
          ?.filter((p) => p.key !== "All")
          ?.map((brand) => brand.key),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        interval: this.sovInterval,
        feature_id: this.featureId,
      };

      const url = "/api/v2/indian_clients/pincode/availability";
      try {
        const res = await self.$http.post(url, payload);
        this.availabilityTrendDataShow = res.data.data_present;
        this.viewTrendLineData = res.data.data;
        this.processPincodeLevelTrendlineGraph();
        self.loader1 = false;
      } catch (err) {
        self.loader1 = false;
        console.log("err");
        this.availabilityTrendDataShow = false;
      }
    },

    getModalTrendlineGraphData() {
      // console.log('check')
      let self = this;
      this.loader = true;
      this.availabilityPinCodeModalDataShow = false;
      this.viewModalTrendLineData = "";
      let payload = {
        start_date: moment(this.trendlineModalDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.trendlineModalDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        platform: [this.selectedPlatformTrendlineModal.key],
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      if (this.selectedSegmentTrendlineModal.key != "all") {
        payload.segment = this.selectedSegmentTrendlineModal.key;
      }

      if (Object.keys(this.selectedProductTrendlineModal).length) {
        payload.product = [this.selectedProductTrendlineModal.key];
      }
      if (this.selectedPinTrendLineModal.length) {
        payload.pincode = this.selectedPinTrendLineModal.map((data) => data);
      }
      const url = "/api/v2/indian_clients/pincode/availability";
      self.$http.post(url, payload).then(
        (res) => {
          this.availabilityPinCodeModalDataShow = res.data.data_present;
          this.viewModalTrendLineData = res.data.data;
          // window.location = response.body.data;
          this.processPincodeLevelModalTrendlineGraph();
          self.loader = false;
        },
        (err) => {
          self.loader = false;
        }
      );
    },

    async getStateWiseData() {
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((subcat) => subcat.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let self = this;
      this.loader2 = true;
      this.procedIndiaMapData = [];
      this.viewIndiaMapData = "";
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        platforms: [this.selectedPlatform?.key],
        category: this.finalSelectedCategory,
        pincode: this.lossSelectedPIN,
        batch: this.lossSelectedBatch?.batch,
        brand: this.lossSelectedBrand
          ?.filter((p) => p.key !== "All")
          ?.map((brand) => brand.key),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      if (this.selectedSegementForTrendline.key != "all") {
        payload.segment = this.selectedSegementForTrendline.key;
      }
      if (this.selectedProductListForTrendline.length) {
        payload.product = this.selectedProductListForTrendline;
      }
      const url = "/api/v2/indian_clients/availability/map";
      try {
        const response = await self.$http.post(url, payload);
        self.loader2 = false;
        this.indiaMapAvailabilityDataShow = response.body.data_present;
        this.viewIndiaMapData = response.body.data;
        if (this.viewIndiaMapData.length) this.processIndiaMapData();
      } catch (err) {
        self.loader2 = false;
        this.indiaMapAvailabilityDataShow = false;
        console.log("err");
      }
    },

    getSegmentWiseProductListData() {
      let self = this;
      //   this.loader3 = true;
      let payload = {
        timestamp: moment(this.trendlineModalDateRange.endData).format(
          "YYYY-MM-DD"
        ),
        client: this.client,
      };
      const url = "/api/v2/indian_clients/segment/list";
      self.$http
        .post(url, {
          language: this.$store.state.DemoStore.selectedLanguage.key,
          feature_id: this.featureId,
        })
        .then((response) => {
          this.loader3 = false;
          if (Object.keys(response.data.data).length) {
            this.storecategoryMap = response.data.category_map;
            this.viewSegmentPlatformAndProductData =
              response.data.data_new_other;
            this.viewPlatformList = response.data.platform;
            //   this.selectedTrendLinePlatform = this.viewPlatformList[0];
            //   this.tempSelectedTrendLinePlatform = this.viewPlatformList[0];

            this.setPlatformWiseData(true);
            this.init();
            this.processSegmentData();
            self.loader3 = false;
          } else {
            this.loader = false;
            this.loader1 = false;
            this.loader3 = false;
            this.loader2 = false;
            this.loader8 = false;
          }
        })
        .catch((err) => {
          self.loader3 = false;
          console.log("err", err);
        });
    },

    processSegmentData() {
      this.viewSegmentData = Object.keys(
        this.viewSegmentPlatformAndProductData[this.selectedTrendLinePlatform]
      );

      if (
        this.viewSegmentData.includes(this.selectedSegementForTrendline.key)
      ) {
        this.selectedSegementForTrendline = this.selectedSegementForTrendline;
      } else {
        this.selectedSegementForTrendline = {
          key: "all",
          value: "All Categories",
        };
      }
      this.processProductListOfSegment();
    },

    processSegmentData() {
      let segments = Object.keys(
        this.viewSegmentPlatformAndProductData[
          this.selectedTrendLinePlatform.key
        ]
      );
      this.viewSegmentData = segments.map((segmentKey) => {
        const mappedCategory = this.storecategoryMap.find(
          (category) => category.key === segmentKey
        );
        return {
          key: segmentKey,
          value: mappedCategory
            ? mappedCategory.value
            : segmentKey.replace(/_/g, " "),
        };
      });

      // console.log(this.viewSegmentData, 'check it')
      if (
        this.viewSegmentData.some(
          (segment) => segment.key === this.selectedSegementForTrendline.key
        )
      ) {
        this.selectedSegementForTrendline = this.selectedSegementForTrendline;
      } else {
        this.selectedSegementForTrendline =
          this.getAllCategoryforAllKeyOption();
      }

      this.processProductListOfSegment();
    },

    processProductListOfSegment() {
      this.viewProductList = "";
      this.selectedProductListForTrendline = [];
      if (this.selectedSegementForTrendline.key === "all") {
        let temp = [];
        for (let [segment, productName] of Object.entries(
          this.viewSegmentPlatformAndProductData[
            this.selectedTrendLinePlatform.key
          ]
        )) {
          temp = temp.concat(productName);
        }
        this.viewProductList = temp;
      } else {
        this.viewProductList =
          this.viewSegmentPlatformAndProductData[
            this.selectedTrendLinePlatform.key
          ][this.selectedSegementForTrendline.key];
      }
      // this.getPieChartData();
      this.getTrendlineGraphData();
      this.getStateWiseData();
      this.getPieChartData();
    },

    processSegmentModalData(isModal) {
      // if(localStorage.availability_matrix_last_update && this.selectedPlatformTrendlineModal){
      //   let availability_matrix_last_update = JSON.parse(localStorage.availability_matrix_last_update)
      //   this.trendlineModalDateRange.startDate = moment(availability_matrix_last_update[this.selectedPlatformTrendlineModal.toLowerCase()].end_date).subtract(1, 'week').format("YYYY-MM-DD");
      //   this.trendlineModalDateRange.endDate = moment(availability_matrix_last_update[this.selectedPlatformTrendlineModal.toLowerCase()].end_date).format("YYYY-MM-DD");
      // }else{
      if (isModal) {
        this.trendlineModalDateRange.startDate = moment(this.date.startDate)
          .subtract(1, "week")
          .format("YYYY-MM-DD");
        this.trendlineModalDateRange.endDate = moment(this.date.endDate).format(
          "YYYY-MM-DD"
        );
        this.tableModalDateRangeMin = moment(
          this.viewLastUpdatedData.start_date
        ).format("YYYY-MM-DD");
        this.tableModalDataRangeMax = moment(
          this.viewLastUpdatedData.end_date
        ).format("YYYY-MM-DD");
      }

      // this.viewModalSegmentData = Object.keys(this.viewSegmentPlatformAndProductData[this.selectedPlatformTrendlineModal])
      // if (this.viewModalSegmentData.includes(this.selectedSegementForTrendlineModal)) {
      // 	this.selectedSegementForTrendlineModal = this.selectedSegementForTrendlineModal
      // }
      // else {
      // 	this.selectedSegementForTrendlineModal = 'all'
      // }
      // console.log("cgecj tge data", this.viewSegmentPlatformAndProductData)
      // let segments = Object.keys(
      //   this.allCategory[
      //     this.selectedPlatformTrendlineModal.key
      //   ]
      // );
      this.viewModalSegmentData = [];
      this.allCategory[this.selectedPlatformTrendlineModal.key.toLowerCase()].forEach((segment) => {
        if(segment.child.length>0){
          segment.child.forEach((subCat)=>{
             this.viewModalSegmentData.push( {
              key: subCat.key,
              value: segment.value+" - "+subCat.value
            })
          })
        }
      });
      // this.viewModalSegmentData = segments.map((segmentKey) => {
      //   const mappedCategory = this.storecategoryMap.find(
      //     (category) => category.key === segmentKey
      //   );
      //   return {
      //     key: segmentKey,
      //     value: mappedCategory
      //       ? mappedCategory.value
      //       : segmentKey.replace(/_/g, " "),
      //   };
      // });

      if (
        this.viewModalSegmentData.some(
          (segment) => segment.key === this.selectedSegmentTrendlineModal.key
        )
      ) {
        this.selectedSegmentTrendlineModal = this.viewModalSegmentData.filter(cat=>cat.key===this.selectedSegmentTrendlineModal.key);
      } else {
        this.selectedSegmentTrendlineModal =
          this.getAllCategoryforAllKeyOption();
      }
      this.processModalProductListOfSegment(isModal);
    },

    processModalProductListOfSegment(isModal) {
      this.viewModalProductList = "";
      if (isModal)
        this.selectedProductTrendlineModal = this.selectedProductTrendlineModal;
      else this.selectedProductTrendlineModal = [];

      if (this.selectedSegmentTrendlineModal.key === "all") {
        let temp = [];
        for (let [segment, productName] of Object.entries(
          this.viewSegmentPlatformAndProductData[
            this.selectedPlatformTrendlineModal.key
          ]
        )) {
          temp = temp.concat(productName);
        }
        this.viewModalProductList = temp;
      } else {
        this.viewModalProductList =
          this.viewSegmentPlatformAndProductData[
            this.selectedPlatformTrendlineModal.key
          ][this.selectedSegmentTrendlineModal[0].key];
      }
      // this.getPieChartData();
      this.getModalTrendlineGraphData();
    },

    changeProductName() {
      this.getTrendlineGraphData();
      this.getStateWiseData();
    },

    processIndiaMapData() {
      this.procedIndiaMapData = [];
      for (let [key, stateName] of Object.entries(this.indiaStateMapper)) {
        let matchingState = this.viewIndiaMapData.find(
          (stateData) => stateData.state === stateName
        );
        if (matchingState) {
          if (matchingState.percentage_available >= 90) {
            this.procedIndiaMapData.push([
              key,
              matchingState.percentage_available,
              "rgba(173, 247, 182, 1)",
            ]);
          } else if (
            matchingState.percentage_available < 90 &&
            matchingState.percentage_available > 70
          ) {
            this.procedIndiaMapData.push([
              key,
              matchingState.percentage_available,
              "rgba(194, 195, 255, 1)",
            ]);
          } else if (
            matchingState.percentage_available <= 70 &&
            matchingState.percentage_available > 20
          ) {
            this.procedIndiaMapData.push([
              key,
              matchingState.percentage_available,
              "rgba(255, 242, 194, 1)",
            ]);
          } else {
            this.procedIndiaMapData.push([
              key,
              matchingState.percentage_available,
              "rgba(255, 211, 211, 1)",
            ]);
          }
        } else {
          this.procedIndiaMapData.push([key, -105, "#f0f0f0"]);
        }
      }
    },

    processPincodeLevelTrendlineGraph() {
      this.procedTrandLineData = {};
      let seriesData = [
        {
          name: `${
            this.translatedLang["Availability"][this.selectedLanguage.key]
          } %`,
          color: "#47A694",
          // tooltip: { valueSuffix: "%" },
          marker: {
            enabled: true,
            lineWidth: 2,
            fillColor: "white",
            lineColor: "#46A493",
            radius: 5,
          },
          dataLabels: {
            enabled: true,
            allowOverlap: true,
            style: { fontWeight: 0 },
            formatter: function () {
              return this.point.y + "%";
            },
          },
          data: [],
        },
      ];
      let xAxisData = [];
      for (let data of this.viewTrendLineData) {
        xAxisData.push(moment(data.date).format("MMM DD, YY"));
        seriesData[0].data.push(data.percentage_available);
      }
      this.procedTrandLineData.id = "pinLevelGraph";
      this.procedTrandLineData.xAxis = xAxisData;
      this.procedTrandLineData.seriesData = seriesData;
    },

    processTrendLineModal(platform, segment, productName) {

      let findPlatform = this.viewPlatformList.find(
        (platformData) => platformData.key === platform
      );

      this.showTrendLineModal = true;
      this.procedModalTrandLineData = { xAxis: [] };
      this.selectedPlatformTrendlineModal = findPlatform;
      if (segment.key === "all") {
        this.selectedSegmentTrendlineModal =
          this.getAllCategoryforAllKeyOption();
      } else {
        // this.selectedSegmentTrendlineModal = { key: segment, value: segment.replace('_', ' ') };
        const mappedCategory = this.storecategoryMap.find(
          (category) => category.key === segment.key
        );

        this.selectedSegmentTrendlineModal = {
          key: mappedCategory.key,
          value: mappedCategory
            ? mappedCategory.value
            : segment.replace(/_/g, " "),
        };
      }
      this.selectedProductTrendlineModal = productName;
      this.selectedPinTrendLineModal = this.lossSelectedPincodeProductPIN;
      this.processSegmentModalData(true);
      this.getPinListForModalTrendLine();
      // this.getModalTrendlineGraphData();
    },

    processModal(all_data, heading, check) {
      this.modalData.heading = heading;
      if(this.modalData.tableHeader.length==3){
        this.modalData.tableHeader.pop();
      }
      if(check==0){
        this.modalData.tableHeader.push({ key: "status", value: "Status" })
      }
      let modified_data = JSON.parse(JSON.stringify(all_data));
      modified_data = modified_data.filter((location) => {
        location.data = location.data.filter(
          (pincode_data) => pincode_data.available == check
        );
        if (location.data.length) return true;
        else return false;
      });
      this.modalData.tableData = modified_data;
     
      this.showModal = true;
    },

    processPincodeLevelModalTrendlineGraph() {
      this.procedModalTrandLineData = {};
      let seriesData = [
        {
          name: `${
            this.translatedLang["Availability"][this.selectedLanguage.key]
          } %`,
          color: "#47A694",
          // tooltip: { enabled: false, valueSuffix: "%" },
          marker: {
            enabled: true,
            lineWidth: 2,
            fillColor: "white",
            lineColor: "#46A493",
            radius: 5,
          },
          dataLabels: {
            enabled: true,
            allowOverlap: true,
            style: { fontWeight: 0 },
            formatter: function () {
              return this.point.y + "%";
            },
          },
          data: [],
        },
      ];

      let xAxisData = [];
      for (let data of this.viewModalTrendLineData) {
        xAxisData.push(moment(data.date).format("MMM DD, YY"));
        seriesData[0].data.push(data.percentage_available);
      }
      this.procedModalTrandLineData.id = "pinLevelModalGraph";
      this.procedModalTrandLineData.xAxis = xAxisData;
      this.procedModalTrandLineData.seriesData = seriesData;
    },

    getAllCategoryforEmptyKeyOption() {
      if (
        !this.translatedLang ||
        !this.selectedLanguage ||
        !this.translatedLang["All Categories"]
      ) {
        return {
          key: "",
          value: "All Categories",
        };
      }

      return {
        key: "",
        value:
          this.translatedLang["All Categories"][this.selectedLanguage.key] ||
          "All Categories",
      };
    },

    getAllCategoryforAllKeyOption() {
      if (
        !this.translatedLang ||
        !this.selectedLanguage ||
        !this.translatedLang["All Categories"]
      ) {
        return {
          key: "all",
          value: "All Categories",
        };
      }

      return {
        key: "all",
        value:
          this.translatedLang["All Categories"][this.selectedLanguage.key] ||
          "All Categories",
      };
    },

    getSegmentListData() {
      let self = this;
      this.loader4 = true;
      let payload = {
        timestamp: moment(this.date.startDate).format("YYYY-MM-DD"),
        client: this.client,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      const url = "/api/v2/india_clients/pincode_category";
      self.$http
        .post(url, payload)
        .then((response) => {
          // self.category = response.data.data.category_data;
          self.segmentDropdown.options = response.data.data.data_new;
          // self.segmentDropdown.productList = response.data.data.products_name_new;
          self.segmentDropdown.productList =
            response.data.data.products_name_other;
          this.filterProcutListForAvailMetricTable(false);
          self.segmentDropdown.isSegment = response.data.data.is_segment;
          self.loader4 = false;
        })
        .catch((err) => {
          self.loader4 = false;
          console.log("err", err);
        });
    },

    filterProcutListForAvailMetricTable(isTable) {
      // console.log("check the data", this.segmentDropdown.productList)
      this.segmentDropdown.productFilterList = [];
      if (this.segmentDropdown.selectedSegment.key != "" && isTable) {
        this.segmentDropdown.selectedProduct = "";
      }
      if (this.segmentDropdown.selectedSegment.key == "") {
        for (let [segment, segmentData] of Object.entries(
          this.segmentDropdown.productList
        )) {
          segmentData.forEach((productName) => {
            this.segmentDropdown.productFilterList.push(productName);
          });
          // this.segmentDropdown.productFilterList.push.apply(this.segmentDropdown.productFilterList,segmentData)
        }
      } else {
        this.segmentDropdown.productFilterList =
          this.segmentDropdown.productList[
            this.segmentDropdown.selectedSegment.key
          ];
      }
    },
    getPinListForTrendLine() {
      let self = this;
      this.loader5 = true;
      let payload = {
        timestamp: moment(this.lossBuyboxTableDateRange.endDate).format("YYYY-MM-DD"),
        client: this.client,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      const url = "/api/v2/india_client/pincode_list";
      // const url = "/api/india_client/pincode_list";
      self.$http.post(url, payload).then(
        (response) => {
          // window.location = response.body.data;
          this.viewPinListTrendLine = response.data.data;
          self.loader5 = false;
        },
        (err) => {
          self.loader5 = false;
        }
      );
    },

    getPinListForModalTrendLine() {
      let self = this;
      this.loader6 = true;
      this.viewPinListModalTrendLine = [];
      let payload = {
        timestamp: moment(this.trendlineModalDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        client: this.client,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      const url = "/api/v2/india_client/pincode_list";
      // const url = "/api/india_client/pincode_list";
      self.$http.post(url, payload).then(
        (response) => {
          // window.location = response.body.data;
          this.viewPinListModalTrendLine = response.data.data;
          this.viewPinListModalTrendLine.unshift({
            id: "all",
            label:
              this.translatedLang["All"][this.selectedLanguage.key] || "All",
            child: [],
          });
          self.loader6 = false;
        },
        (err) => {
          self.loader6 = false;
        }
      );
    },

    getPinListData() {
      let self = this;
      // this.loader7 = true;
      let payload = {
        timestamp: moment(this.date.startDate).format("YYYY-MM-DD"),
        client: this.client,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      const url = "/api/v2/india_client/pincode_list";
      // const url = "/api/india_client/pincode_list";
      self.$http.post(url, payload).then(
        (response) => {
          // window.location = response.body.data;
          this.locationDropdown.options = response.data.data;
          // this.locationDropdown = response.data.data
          // self.loader7 = false;
        },
        (err) => {
          // self.loader7 = false;
        }
      );
    },

    async getTableData() {
      if (this.selectedPincodeProductTableSubCategory.length) {
        this.finalSelectedPincodeProductCategory =
          this.selectedPincodeProductTableSubCategory
            ?.filter((subcat) => subcat.key !== "All")
            .map((subcat) => subcat.key);
      } else if (
        !this.selectedPincodeProductTableSubCategory.length &&
        this.selectedPincodeProductTableCategory.length
      ) {
        this.finalSelectedPincodeProductCategory =
          this.selectedPincodeProductTableCategory?.flatMap((data) => {
            return data.child?.map((subcat) => subcat.key);
          });
      } else {
        this.finalSelectedPincodeProductCategory = [];
      }
      this.loader8 = true;
      this.mainTableData.data = [];
      const url = "/api/v2/indian_clients/availability/product";
      let payload = {
        start_date: moment(this.date.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.date.endDate).format("YYYY-MM-DD"),
        platforms: this.selectedPincodeProductPlatform
          ?.filter((platform) => platform.key != "All")
          ?.map((platform) => platform.key),
        category: this.finalSelectedPincodeProductCategory,
        pincode: this.lossSelectedPincodeProductPIN?.length
          ? this.lossSelectedPincodeProductPIN
          : [],
        batch: this.lossSelectedPincodeProductBatch.batch,
        brand: this.lossSelectedPincodeProductBrand?.length
          ? this.lossSelectedPincodeProductBrand
              ?.filter((brand) => brand.key !== "All")
              .map((brand) => brand.key)
          : [],
        language: this.$store.state.DemoStore.selectedLanguage.key,
        product: this.lossSelectedPincodeProductId?.length
          ? this.lossSelectedPincodeProductId
              ?.filter((product) => product.key !== "All")
              .map((product) => product.key)
          : [],
        feature_id: this.featureId,
      };

      try {
        const Response = await this.$http.post(url, payload);
        this.availabilityTableDataShow = Response.data.data_present;
        const resData = Response.data?.data;
        const modifiedTableData = resData?.data;
        const headerData = resData?.headers;
        this.mainTableData.header = [];
        this.mainTableData.data = modifiedTableData;
        this.mainTableData.platform = resData?.platform;
        this.mainTableData.unModifiedHeaderData = headerData;
        this.segmentDropdown.selectedSegment =
          this.getAllCategoryforEmptyKeyOption();
        headerData?.forEach((data) => {
          if (data.key == "name")
            this.mainTableData.header.unshift({
              key: "product_name",
              value: data.label,
              img: data.img_url,
            });
          else
            this.mainTableData?.header.push({
              key: data.key,
              value: data.label,
              img: data.img_url,
            });
        });
        this.$nextTick(() => {
          this.dataTable();
        });
        this.loader8 = false;
      } catch (err) {
        this.loader8 = false;
        this.availabilityTableDataShow = false;
        console.log(err);
      }
    },

    dataTable() {
      // Destroy if already initialized
      if ($.fn.DataTable.isDataTable("#indiagate-dashboard-table")) {
        $("#indiagate-dashboard-table").DataTable().clear().destroy();
      }

      // Now initialize
      $("#indiagate-dashboard-table").DataTable({
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
          searchPlaceholder: "Search...",
        },
        pagingType: "full_numbers",
        searching: true,
        order: [],
        autoWidth: false,
      });

      $("#indiagate-dashboard-table").wrap(
        "<div style='overflow:auto; width:100%; position:relative;'></div>"
      );

      $("#indiagate-dashboard-table").css("min-width", "1000px");

      $("#indiagate-dashboard-table" + "_filter > label").append(`
        <div class='search_icon'>
            <img src='/Icons_SVG/Search.svg' width='20' />
        </div>
        `);
    },
    processSelectedPin() {
      if (this.locationDropdown.checkSelectedPins) {
        this.locationDropdown.selectedPin =
          this.locationDropdown.checkSelectedPins.map((obj) => obj);
        this.getSegmentListData();
        this.getTableData();
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
#dashboard {
  font-family: "Poppins", sans-serif !important;
}

.lastUpdated {
  color: #065559;
  font-size: 12px;
  padding: 6px 12px;
  border: 1px solid var(--base_color-80);
  border-radius: 6px;
}

.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
  cursor: pointer;
}

.CustomDropdown {
  border: 1px solid rgb(172, 172, 172);
  z-index: 999999999 !important;
  margin-left: 5px;
  border-radius: 3px;
  margin-top: 2px;
  position: absolute;
  background: white;
  width: 200px;
  right: 12px;
}

.customItem {
  padding: 3px 5px 2px 8px;
  cursor: pointer;
  color: var(--primary_brand);
}

.customItem:hover {
  background: var(--primary_brand-10);
}

.revampCard {
  border-radius: 0.7rem !important;
  border: none !important;
  margin: 10px;
  margin-bottom: 1rem;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 12px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

.avail_modal_cta {
  color: #5e5e5e;
  text-decoration: none;
  background-color: transparent;
}

.unavail_modal_cta {
  color: #5e5e5e;
  text-decoration: none;
  background-color: transparent;
}

.unavail_modal_cta:hover {
  text-decoration: underline;
  cursor: pointer;
}

.avail_modal_cta:hover {
  text-decoration: underline;
  cursor: pointer;
}

.info_mrp {
  text-align: start;
  padding-left: 5px;
  color: var(--primary_brand);
  font-weight: 500;
  font-size: 12px;
}

.info_price {
  text-align: start;
  padding-left: 5px;
  color: var(--primary_brand);
  font-weight: 500;
  font-size: 12px;
}

.icon {
  font-size: 15px;
  color: var(--primary_brand);
  /* z-index: 1000; */
}

.icon:hover {
  cursor: pointer !important;
}

.icon_container {
  /* display: flex; */
  /* justify-content: end; */
  /* min-width: 140px; */
  /* margin-bottom: -20px; */
}

.borderBottom {
  border-bottom: 1px solid rgba(212, 212, 212, 1) !important;
  margin: 10px 0px !important;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #ffffff !important;
  background-color: var(--primary_brand-80) !important;
  border-color: var(--primary_brand-80) !important;
  line-height: 35px !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-weight: 600 !important;
}

.btn-outline-secondary {
  line-height: 35px !important;
  /* border-radius: 5px; */
  color: var(--primary_brand) !important;
  background: var(--primary_brand-10) !important;
  border: 1px solid var(--primary_brand-10) !important;
  font-family: "poppins" !important;
  padding: 0px 20px !important;
}

.btn-group {
  background: var(--primary_brand-10) !important;
  border-radius: 5px !important;
  font-family: "poppins" !important;

  /* border: 1px solid var(--primary_brand-10); */
}
</style>

<style>
.customModal {
  z-index: 999 !important;
}

/* .modal-title {
	font-weight: 600 !important;
	font-family: "poppins";
	width: 100%;
	height: 35px;
	overflow: hidden;
	text-overflow: ellipsis;
}

.modal-header {
	background: var(--primary_brand-20) !important;
	color: var(--base_color);
	border: none;
	font-family: "poppins";
	border-radius: 5px 0px 0px 0px !important;
}

.modal-header .close {
	color: black;
	text-shadow: none;
	position: absolute;
	top: -2px;
	right: -6px;
	font-size: 30px;
	background: var(--primary_brand-10);
	opacity: inherit;
	padding: 5px 10px;
	border-radius: 25px;
} */

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
</style>

<style>
.vue-treeselect__control {
  height: 35px !important;
  border: 1px solid rgba(75, 75, 75, 0.4) !important;
  border-radius: 5px !important;
}

.vue-treeselect__multi-value {
  height: 30px !important;
  overflow: auto !important;
}

.vue-treeselect__multi-value-item {
  background-color: rgba(6, 85, 89, 1) !important;
  color: white !important;
}

.vue-treeselect__value-remove {
  color: white !important;
}

.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  font-family: "poppins";
}

.customMultiselect .multiselect__input {
  border: var(--base_color-20) !important;
  height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
  outline: none !important;
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
  background-color: #44777a !important;
  color: white !important;
  font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
  font-size: 10px !important;
  padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

/* .modal-title {
	font-weight: 600 !important;
	font-family: "poppins";
}

.modal-header {
	background: var(--primary_brand-20) !important;
	color: var(--base_color);
	border: none;
	font-family: "poppins";
	display: flex !important;
	justify-content: start !important;
	padding-bottom: 1rem !important;
}

.modal-header .close {
	color: black;
	text-shadow: none;
	position: absolute;
	top: -2px;
	right: -6px;
	font-size: 30px;
	background: var(--primary_brand-10);
	opacity: inherit;
	padding: 5px 10px;
	border-radius: 25px;
} */

.lineBetween {
  padding-top: 10px !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

@media only screen and (max-width: 1700px) {
  .primarycolor {
    padding: 5px 10px !important;
  }

  .custom_dropdown {
  }
}
#avaibility-filters .multiselect__strong {
  display: none !important;
}
</style>
